import { resolveComponent, openBlock, createBlock, mergeProps, withCtx, renderSlot, getCurrentInstance, createElementBlock, toDisplayString, createCommentVNode, createElementVNode, Fragment, renderList, createTextVNode, resolveDynamicComponent, normalizeProps, guardReactiveProps, computed, useCssVars, normalizeClass, inject, createVNode, createSlots, withModifiers, ref, toRaw, watch, nextTick, onMounted, normalizeStyle, provide, resolveDirective, Teleport, Transition, withDirectives, h, isVNode, render, pushScopeId, popScopeId, onBeforeUnmount, reactive, onUnmounted, defineComponent } from "vue";
import { NOOP, isArray } from "@vue/shared";
import { useLocaleInject, useLocale as useLocale$1, ElPagination, ElMessage } from "element-plus";
import PopupManager from "element-plus/packages/utils/popup-manager";
import en$1 from "element-plus/lib/locale/lang/en";
import zh from "element-plus/lib/locale/lang/zh-cn";
var theme = "";
var index$2 = "";
var _sfc_main$19 = {
  name: "GjAlert",
  props: {
    closable: {
      type: Boolean,
      "default": false
    },
    border: {
      type: Boolean,
      "default": false
    },
    type: {
      type: String,
      "default": "info",
      validator: function validator(t) {
        return ["info", "success", "warning", "error"].includes(t);
      }
    }
  }
};
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_alert = resolveComponent("el-alert");
  return openBlock(), createBlock(_component_el_alert, mergeProps(_ctx.$attrs, {
    closable: $props.closable,
    type: $props.type,
    "class": ["gj-alert", "gj-alert--".concat($props.type), $props.border && "is-border"]
  }), {
    title: withCtx(function() {
      return [renderSlot(_ctx.$slots, "title")];
    }),
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16, ["closable", "type", "class"]);
}
_sfc_main$19.render = _sfc_render$18;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var isMeaningful = function isMeaningful2(object) {
  return object !== null && object !== void 0 && object !== "";
};
var toFixed = function toFixed2(num) {
  var digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  if (typeof num === "number" && isNaN(num))
    return null;
  return Number.parseFloat(num).toFixed(digits);
};
function useGlobalConfig() {
  var vm = getCurrentInstance();
  if ("$GPLUS" in vm.proxy) {
    return vm.proxy.$GPLUS;
  }
  return {};
}
var withInstall = function withInstall2(component, extra) {
  component.install = function(app) {
    for (var _i = 0, _arr = [component].concat(_toConsumableArray(Object.values(extra !== null && extra !== void 0 ? extra : {}))); _i < _arr.length; _i++) {
      var comp2 = _arr[_i];
      app.component(comp2.name, comp2);
    }
  };
  if (extra) {
    for (var _i2 = 0, _Object$entries = Object.entries(extra); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], comp = _Object$entries$_i[1];
      component[key] = comp;
    }
  }
  return component;
};
var withNoopInstall = function withNoopInstall2(component) {
  component.install = NOOP;
  return component;
};
var GjAlert = withInstall(_sfc_main$19);
var _sfc_main$18 = {
  props: {
    title: {
      type: String,
      "default": null
    },
    rules: {
      type: Array,
      required: true,
      "default": function _default() {
        return [];
      }
    }
  }
};
var _hoisted_1$w = {
  "class": "gj-alert--text"
};
var _hoisted_2$n = {
  key: 0
};
var _hoisted_3$i = /* @__PURE__ */ createElementVNode("span", null, null, -1);
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$w, [$props.title ? (openBlock(), createElementBlock("p", _hoisted_2$n, toDisplayString($props.title), 1)) : createCommentVNode("", true), createElementVNode("ul", null, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.rules, function(item, index2) {
    return openBlock(), createElementBlock("li", {
      key: index2
    }, [_hoisted_3$i, createTextVNode(" " + toDisplayString(item), 1)]);
  }), 128))])]);
}
_sfc_main$18.render = _sfc_render$17;
var _sfc_main$17 = {
  name: "GjAlertSuper",
  components: {
    rule: _sfc_main$18
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: function validator2(t) {
        return ["rule"].includes(t);
      }
    }
  }
};
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.mode), normalizeProps(guardReactiveProps(_ctx.$attrs)), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$17.render = _sfc_render$16;
var GjAlertSuper = withInstall(_sfc_main$17);
var _sfc_main$16 = {
  name: "GjBadge"
};
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_badge = resolveComponent("el-badge");
  return openBlock(), createBlock(_component_el_badge, mergeProps(_ctx.$attrs, {
    "class": ["gj-badge"]
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$16.render = _sfc_render$15;
var GjBadge = withInstall(_sfc_main$16);
var index_vue_vue_type_style_index_0_scoped_true_lang = "";
var __default__$1 = {
  name: "GjDivider",
  props: {
    mode: {
      type: String,
      "default": "horizontal"
    },
    type: {
      type: String,
      "default": "inner"
    }
  },
  setup: function setup(props) {
    return {
      classMode: computed(function() {
        return "gj-divider-".concat(props.mode);
      }),
      color: computed(function() {
        return "var(--color-grey-".concat(props.type === "inner" ? 4 : 3, ")");
      })
    };
  }
};
var __injectCSSVars__$1 = function __injectCSSVars__() {
  useCssVars(function(_ctx) {
    return {
      "71c4278a": _ctx.color
    };
  });
};
var __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? function(props, ctx) {
  __injectCSSVars__$1();
  return __setup__$1(props, ctx);
} : __injectCSSVars__$1;
var _sfc_main$15 = __default__$1;
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["gj-divider", $setup.classMode])
  }, null, 2);
}
_sfc_main$15.render = _sfc_render$14;
_sfc_main$15.__scopeId = "data-v-1ed4bd5a";
var useLocale = function useLocale2() {
  return inject("ElLocaleInjection") || useLocaleInject() || useLocale$1();
};
var _sfc_main$14 = {
  name: "GjBreadcrumb",
  components: {
    GjDivider: _sfc_main$15
  },
  emits: ["back"],
  setup: function setup2(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var goBack = function goBack2() {
      return emit("back");
    };
    return {
      t,
      goBack
    };
  }
};
var _hoisted_1$v = {
  "class": "gj-breadcrumb"
};
var _hoisted_2$m = /* @__PURE__ */ createElementVNode("i", {
  "class": "el-icon-back"
}, null, -1);
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_divider = resolveComponent("gj-divider");
  var _component_el_breadcrumb = resolveComponent("el-breadcrumb");
  return openBlock(), createElementBlock("div", _hoisted_1$v, [createElementVNode("div", {
    "class": "back-box",
    onClick: _cache[0] || (_cache[0] = function() {
      return $setup.goBack && $setup.goBack.apply($setup, arguments);
    })
  }, [_hoisted_2$m, createTextVNode(" " + toDisplayString($setup.t("el.pageHeader.title")), 1)]), createVNode(_component_gj_divider, {
    mode: "vertical"
  }), createVNode(_component_el_breadcrumb, {
    "separator-class": "el-icon-arrow-right"
  }, {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  })]);
}
_sfc_main$14.render = _sfc_render$13;
var GjBreadcrumb = withInstall(_sfc_main$14);
var _sfc_main$13 = {
  name: "GjBreadcrumbItem"
};
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = resolveComponent("el-breadcrumb-item");
  return openBlock(), createBlock(_component_el_breadcrumb_item, mergeProps(_ctx.$attrs, {
    "class": "gj-breadcrumb-item"
  }), createSlots({
    _: 2
  }, [_ctx.$slots["default"] ? {
    name: "default",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    })
  } : void 0]), 1040);
}
_sfc_main$13.render = _sfc_render$12;
var GjBreadcrumbItem = withInstall(_sfc_main$13);
var _sfc_main$12 = {
  name: "GjButton",
  props: {
    type: String,
    "default": null,
    validator: function validator3(v) {
      return ["primary", "success", "info", "warning", "danger", "minor", "text"].includes(v);
    }
  },
  setup: function setup3(props) {
    var defaultType = computed(function() {
      return ["primary", "success", "info", "warning", "danger", "text"].includes(props.type) ? props.type : "default";
    });
    return {
      defaultType
    };
  }
};
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = resolveComponent("el-button");
  return openBlock(), createBlock(_component_el_button, mergeProps(_ctx.$attrs, {
    type: $setup.defaultType,
    "class": ["gj-button", $props.type === "minor" && "el-button--minor"],
    onKeydown: _cache[0] || (_cache[0] = withModifiers(function() {
    }, ["prevent"]))
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16, ["type", "class"]);
}
_sfc_main$12.render = _sfc_render$11;
var _sfc_main$11 = {
  name: "GjButtonIcon",
  props: {
    icon: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    loading: {
      type: Boolean,
      "default": false
    },
    size: {
      type: String,
      "default": "normal",
      validator: function validator4(v) {
        return ["normal", "small", "mini"].includes(v);
      }
    }
  },
  emits: ["click"],
  setup: function setup4(props, _ref) {
    var emit = _ref.emit;
    var handleClick = function handleClick2(evt) {
      emit("click", evt);
    };
    return {
      handleClick
    };
  }
};
var _hoisted_1$u = ["disabled"];
var _hoisted_2$l = {
  key: 0,
  "class": "el-icon-loading"
};
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    "class": normalizeClass(["gj-button-icon", $props.disabled && "is-disabled", "gj-button-icon-".concat($props.size)]),
    disabled: $props.disabled || $props.loading,
    onClick: _cache[0] || (_cache[0] = function() {
      return $setup.handleClick && $setup.handleClick.apply($setup, arguments);
    })
  }, [$props.loading ? (openBlock(), createElementBlock("i", _hoisted_2$l)) : createCommentVNode("", true), $props.icon && !$props.loading ? (openBlock(), createElementBlock("i", {
    key: 1,
    "class": normalizeClass($props.icon)
  }, null, 2)) : createCommentVNode("", true), _ctx.$slots["default"] && !$props.loading ? renderSlot(_ctx.$slots, "default", {
    key: 2
  }) : createCommentVNode("", true)], 10, _hoisted_1$u);
}
_sfc_main$11.render = _sfc_render$10;
var GjButton = withInstall(_sfc_main$12, {
  ButtonIcon: _sfc_main$11
});
var GjButtonIcon = withNoopInstall(_sfc_main$11);
var _sfc_main$10 = {
  name: "GjCheckbox"
};
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_checkbox = resolveComponent("el-checkbox");
  return openBlock(), createBlock(_component_el_checkbox, mergeProps(_ctx.$attrs, {
    "class": ["gj-checkbox"]
  }), createSlots({
    _: 2
  }, [_ctx.$slots["default"] ? {
    name: "default",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    })
  } : void 0]), 1040);
}
_sfc_main$10.render = _sfc_render$$;
var _sfc_main$$ = {
  name: "GjCheckboxGroup"
};
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_checkbox_group = resolveComponent("el-checkbox-group");
  return openBlock(), createBlock(_component_el_checkbox_group, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$$.render = _sfc_render$_;
var GjCheckbox = withInstall(_sfc_main$10, {
  checkboxGroup: _sfc_main$$
});
var GjCheckboxGroup = withNoopInstall(_sfc_main$$);
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _sfc_main$_ = {
  name: "GjFilterGroup"
};
var _hoisted_1$t = {
  "class": "gj-filter-group"
};
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$t, [renderSlot(_ctx.$slots, "default")]);
}
_sfc_main$_.render = _sfc_render$Z;
var emptyImg = "data:image/png;base64,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";
var _sfc_main$Z = {
  name: "GjSelect",
  props: {
    options: {
      type: Array
    },
    labelKey: {
      type: String,
      "default": "text"
    },
    valueKey: {
      type: String,
      "default": "id"
    }
  },
  emits: ["change", "change-object"],
  setup: function setup5(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var root = ref(null);
    var handleChange = function handleChange2(val) {
      emit("change", val);
      if (props.options && props.options.length > 0) {
        if (isArray(val)) {
          emit("change-object", val.map(function(v) {
            return toRaw(props.options).find(function(n) {
              return n[props.valueKey] === v;
            });
          }));
        } else {
          emit("change-object", toRaw(props.options).find(function(v) {
            return v[props.valueKey] === val;
          }));
        }
      }
    };
    return {
      t,
      root,
      emptyImg,
      handleChange
    };
  }
};
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_option = resolveComponent("gj-option");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_el_select = resolveComponent("el-select");
  return openBlock(), createBlock(_component_el_select, mergeProps(_ctx.$attrs, {
    ref: "root",
    clearable: "",
    "class": ["gj-select"],
    onChange: $setup.handleChange
  }), createSlots({
    empty: withCtx(function() {
      return [$props.options && $props.options.length === 0 ? (openBlock(), createBlock(_component_el_empty, {
        key: 0,
        "class": "gj-select__empty",
        image: $setup.emptyImg,
        description: $setup.t("gj.emptyText")
      }, null, 8, ["image", "description"])) : createCommentVNode("", true)];
    }),
    "default": withCtx(function() {
      return [$props.options ? (openBlock(true), createElementBlock(Fragment, {
        key: 0
      }, renderList($props.options, function(item) {
        return openBlock(), createBlock(_component_gj_option, {
          key: item[$props.valueKey],
          label: item[$props.labelKey],
          value: item[$props.valueKey]
        }, null, 8, ["label", "value"]);
      }), 128)) : renderSlot(_ctx.$slots, "default", {
        key: 1
      })];
    }),
    _: 2
  }, [_ctx.$slots.prefix ? {
    name: "prefix",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "prefix")];
    })
  } : void 0]), 1040, ["onChange"]);
}
_sfc_main$Z.render = _sfc_render$Y;
var _sfc_main$Y = {
  name: "GjOption"
};
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = resolveComponent("el-option");
  return openBlock(), createBlock(_component_el_option, mergeProps(_ctx.$attrs, {
    "class": "gj-select-dropdown__item"
  }), createSlots({
    _: 2
  }, [_ctx.$slots["default"] ? {
    name: "default",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    })
  } : void 0]), 1040);
}
_sfc_main$Y.render = _sfc_render$X;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h2 = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, g = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date())
        return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h2 }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return t2 === void 0;
    } }, D = "en", v = {};
    v[D] = M;
    var p = function(t2) {
      return t2 instanceof _2;
    }, S = function(t2, e2, n2) {
      var r2;
      if (!t2)
        return D;
      if (typeof t2 == "string")
        v[t2] && (r2 = t2), e2 && (v[t2] = e2, r2 = t2);
      else {
        var i2 = t2.name;
        v[i2] = t2, r2 = i2;
      }
      return !n2 && r2 && (D = r2), r2 || !n2 && D;
    }, w = function(t2, e2) {
      if (p(t2))
        return t2.clone();
      var n2 = typeof e2 == "object" ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _2(n2);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t2, e2) {
      return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _2 = function() {
      function M2(t2) {
        this.$L = S(t2.locale, null, true), this.parse(t2);
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (e2 === null)
            return new Date(NaN);
          if (O.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if (typeof e2 == "string" && !/Z$/i.test(e2)) {
            var r2 = e2.match(l);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.$x = t2.x || {}, this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return O;
      }, m2.isValid = function() {
        return !(this.$d.toString() === $);
      }, m2.isSame = function(t2, e2) {
        var n2 = w(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return w(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < w(t2);
      }, m2.$g = function(t2, e2, n2) {
        return O.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!O.u(e2) || e2, h3 = O.p(t2), $2 = function(t3, e3) {
          var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, l2 = function(t3, e3) {
          return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, g2 = "set" + (this.$u ? "UTC" : "");
        switch (h3) {
          case c:
            return r2 ? $2(1, 0) : $2(31, 11);
          case f:
            return r2 ? $2(1, M3) : $2(0, M3 + 1);
          case o:
            var D2 = this.$locale().weekStart || 0, v2 = (y2 < D2 ? y2 + 7 : y2) - D2;
            return $2(r2 ? m3 - v2 : m3 + (6 - v2), M3);
          case a:
          case d:
            return l2(g2 + "Hours", 0);
          case u:
            return l2(g2 + "Minutes", 1);
          case s:
            return l2(g2 + "Seconds", 2);
          case i:
            return l2(g2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = O.p(t2), h3 = "set" + (this.$u ? "UTC" : ""), $2 = (n2 = {}, n2[a] = h3 + "Date", n2[d] = h3 + "Date", n2[f] = h3 + "Month", n2[c] = h3 + "FullYear", n2[u] = h3 + "Hours", n2[s] = h3 + "Minutes", n2[i] = h3 + "Seconds", n2[r] = h3 + "Milliseconds", n2)[o2], l2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === f || o2 === c) {
          var y2 = this.clone().set(d, 1);
          y2.$d[$2](l2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          $2 && this.$d[$2](l2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[O.p(t2)]();
      }, m2.add = function(r2, h3) {
        var d2, $2 = this;
        r2 = Number(r2);
        var l2 = O.p(h3), y2 = function(t2) {
          var e2 = w($2);
          return O.w(e2.date(e2.date() + Math.round(t2 * r2)), $2);
        };
        if (l2 === f)
          return this.set(f, this.$M + r2);
        if (l2 === c)
          return this.set(c, this.$y + r2);
        if (l2 === a)
          return y2(1);
        if (l2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[l2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return O.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || $;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h3 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].substr(0, s3);
        }, c2 = function(t3) {
          return O.s(s2 % 12 || 12, t3, "0");
        }, d2 = n2.meridiem || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        }, l2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h3(n2.monthsShort, a2, f2, 3), MMMM: h3(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h3(n2.weekdaysMin, this.$W, o2, 2), ddd: h3(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
        return r2.replace(y, function(t3, e3) {
          return e3 || l2[t3] || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, $2) {
        var l2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, g2 = this - M3, D2 = O.m(this, M3);
        return D2 = (l2 = {}, l2[c] = D2 / 12, l2[f] = D2, l2[h2] = D2 / 3, l2[o] = (g2 - m3) / 6048e5, l2[a] = (g2 - m3) / 864e5, l2[u] = g2 / n, l2[s] = g2 / e, l2[i] = g2 / t, l2)[y2] || g2, $2 ? D2 : O.a(D2);
      }, m2.daysInMonth = function() {
        return this.endOf(f).$D;
      }, m2.$locale = function() {
        return v[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2)
          return this.$L;
        var n2 = this.clone(), r2 = S(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return O.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), b = _2.prototype;
    return w.prototype = b, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
      b[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), w.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _2, w), t2.$i = true), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
      return w(1e3 * t2);
    }, w.en = v[D], w.Ls = v, w.p = {}, w;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var today = {
  text: "\u4ECA\u5929",
  textEn: "Today",
  symbol: "today",
  date: [dayjs(), dayjs()]
};
var yesterday = {
  text: "\u6628\u5929",
  textEn: "Yesterday",
  symbol: "yesterday",
  date: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")]
};
var nearly7 = {
  text: "\u8FD17\u5929",
  textEn: "Nearly 7days",
  symbol: "nearly7",
  date: [dayjs().subtract(7, "day"), dayjs()]
};
var nearly30 = {
  text: "\u8FD130\u5929",
  textEn: "Nearly 30days",
  symbol: "nearly30",
  date: [dayjs().subtract(30, "day"), dayjs()]
};
var thismonth = {
  text: "\u672C\u6708",
  textEn: "This Month",
  symbol: "thismonth",
  date: [dayjs().startOf("month"), dayjs()]
};
var lastmonth = {
  text: "\u4E0A\u6708",
  textEn: "Last Month",
  symbol: "lastmonth",
  date: [dayjs().add(-1, "month").startOf("month"), dayjs().add(-1, "month").endOf("month")]
};
var thisyeartoday = {
  text: "\u672C\u5E74\u81F3\u4ECA",
  textEn: "So far this year",
  symbol: "thisyeartoday",
  date: [dayjs().startOf("year"), dayjs()]
};
var dayconfig = {
  today,
  yesterday,
  nearly7,
  nearly30,
  thismonth,
  lastmonth,
  thisyeartoday
};
var shortType = ["today", "yesterday", "nearly7", "nearly30", "thismonth", "lastmonth", "thisyeartoday"];
var _sfc_main$X = {
  name: "GjDatePicker",
  props: {
    type: {
      type: String,
      required: true
    },
    shortcutsConfig: {
      type: Array,
      "default": function _default2() {
        return [];
      },
      validator: function validator5(t) {
        return t.every(function(v) {
          return shortType.includes(v);
        });
      }
    }
  },
  setup: function setup6(props) {
    var _useLocale = useLocale(), lang = _useLocale.lang;
    var shortcuts2 = ref(getShortcuts(lang.value, props.shortcutsConfig));
    var configChange = ref(false);
    watch(function() {
      return [lang.value, props.shortcutsConfig];
    }, function(_ref) {
      var _ref2 = _slicedToArray(_ref, 2), lang2 = _ref2[0], shortcutsConfig = _ref2[1];
      configChange.value = true;
      shortcuts2.value = getShortcuts(lang2, shortcutsConfig);
      nextTick(function() {
        configChange.value = false;
      });
    });
    function getShortcuts(lang2, shortcutsConfig) {
      if (shortcutsConfig.length > 0) {
        return shortcutsConfig.map(function(v) {
          return {
            text: lang2 === "en" ? dayconfig[v].textEn : dayconfig[v].text,
            value: dayconfig[v].date
          };
        });
      } else {
        if (props.type === "daterange") {
          return shortType.map(function(v) {
            return {
              text: lang2 === "en" ? dayconfig[v].textEn : dayconfig[v].text,
              value: dayconfig[v].date
            };
          });
        } else {
          return [];
        }
      }
    }
    return {
      shortcuts2,
      configChange
    };
  }
};
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_date_picker = resolveComponent("el-date-picker");
  return !$setup.configChange ? (openBlock(), createBlock(_component_el_date_picker, mergeProps({
    key: 0
  }, _ctx.$attrs, {
    type: $props.type,
    shortcuts: $setup.shortcuts2,
    "class": ["gj-date-picker"],
    "popper-class": "gj-date-picker-pop-up"
  }), null, 16, ["type", "shortcuts"])) : createCommentVNode("", true);
}
_sfc_main$X.render = _sfc_render$W;
var _sfc_main$W = {
  name: "GjSelectComposeDatePicker",
  components: {
    gjFilterGroup: _sfc_main$_,
    gjSelect: _sfc_main$Z,
    gjOption: _sfc_main$Y,
    GjDatePicker: _sfc_main$X
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true,
      "default": function _default3() {
        return [];
      }
    },
    labelKey: {
      type: String,
      "default": "text"
    },
    valueKey: {
      type: String,
      "default": "id"
    },
    config: {
      type: Object,
      "default": function _default4() {
        return {
          key: "key",
          value: "value"
        };
      }
    },
    leftWidth: {
      type: Number,
      "default": 90
    },
    rightWidth: {
      type: Number,
      "default": 240
    }
  },
  emits: ["update:modelValue", "change-object", "change", "date-change"],
  setup: function setup7(props, _ref) {
    var emit = _ref.emit;
    var key = ref("");
    var value = ref("");
    onMounted(function() {
      key.value = props.modelValue[props.config.key];
      value.value = props.modelValue[props.config.value];
    });
    watch(function() {
      return props.modelValue[props.config.key];
    }, function(newVal) {
      key.value = newVal;
    });
    watch(function() {
      return props.modelValue[props.config.value];
    }, function(newVal) {
      value.value = newVal;
    });
    watch(key, function() {
      var data = props.modelValue;
      data[props.config.key] = key.value;
      emit("update:modelValue", data);
    });
    watch(value, function() {
      var data = props.modelValue;
      data[props.config.value] = value.value;
      emit("update:modelValue", data);
    });
    var handleChange = function handleChange2(val) {
      emit("change", val);
      if (props.options && props.options.length > 0) {
        var _emit;
        emit("change-object", (_emit = {}, _defineProperty$1(_emit, props.config.key, toRaw(props.options).find(function(v) {
          return v[props.valueKey] === val;
        })), _defineProperty$1(_emit, props.config.value, toRaw(props.modelValue[props.config.value])), _emit));
      }
    };
    var handleDateChange = function handleDateChange2(val) {
      var _emit2;
      emit("date-change", val);
      emit("change-object", (_emit2 = {}, _defineProperty$1(_emit2, props.config.key, toRaw(props.options).find(function(v) {
        return v[props.valueKey] === props.modelValue[props.config.key];
      })), _defineProperty$1(_emit2, props.config.value, toRaw(val)), _emit2));
    };
    return {
      key,
      value,
      handleChange,
      handleDateChange
    };
  }
};
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_option = resolveComponent("gj-option");
  var _component_gj_select = resolveComponent("gj-select");
  var _component_gj_date_picker = resolveComponent("gj-date-picker");
  var _component_gj_filter_group = resolveComponent("gj-filter-group");
  return openBlock(), createBlock(_component_gj_filter_group, null, {
    "default": withCtx(function() {
      return [createVNode(_component_gj_select, {
        modelValue: $setup.key,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
          return $setup.key = $event;
        }),
        style: normalizeStyle({
          "width": $props.leftWidth + "px"
        }),
        clearable: false,
        onChange: $setup.handleChange
      }, {
        "default": withCtx(function() {
          return [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, function(item) {
            return openBlock(), createBlock(_component_gj_option, {
              key: item[$props.valueKey],
              label: item[$props.labelKey],
              value: item[$props.valueKey]
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue", "style", "onChange"]), createVNode(_component_gj_date_picker, mergeProps({
        modelValue: $setup.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function($event) {
          return $setup.value = $event;
        })
      }, _ctx.$attrs, {
        style: {
          "width": $props.rightWidth + "px"
        },
        onChange: $setup.handleDateChange
      }), null, 16, ["modelValue", "style", "onChange"])];
    }),
    _: 1
  });
}
_sfc_main$W.render = _sfc_render$V;
var _sfc_main$V = {
  name: "GjInput",
  setup: function setup8() {
    var inputRef = ref(null);
    return {
      inputRef
    };
  }
};
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = resolveComponent("el-input");
  return openBlock(), createBlock(_component_el_input, mergeProps(_ctx.$attrs, {
    ref: "inputRef",
    "class": ["gj-input"]
  }), createSlots({
    _: 2
  }, [_ctx.$slots.suffix ? {
    name: "suffix",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "suffix")];
    })
  } : void 0, _ctx.$slots.prefix ? {
    name: "prefix",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "prefix")];
    })
  } : void 0, _ctx.$slots.prepend ? {
    name: "prepend",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "prepend")];
    })
  } : void 0, _ctx.$slots.append ? {
    name: "append",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "append")];
    })
  } : void 0]), 1040);
}
_sfc_main$V.render = _sfc_render$U;
var _sfc_main$U = {
  name: "GjSelectLikeInput",
  components: {
    GjInput: _sfc_main$V,
    GjOption: _sfc_main$Y,
    GjSelect: _sfc_main$Z
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true,
      "default": function _default5() {
        return [];
      }
    },
    labelKey: {
      type: String,
      "default": "text"
    },
    valueKey: {
      type: String,
      "default": "id"
    },
    likeOptions: {
      type: Array,
      "default": function _default6() {
        return [{
          label: "\u7CBE\u51C6",
          value: 1
        }, {
          label: "\u6A21\u7CCA",
          value: 0
        }];
      }
    },
    config: {
      type: Object,
      "default": function _default7() {
        return {
          key: "key",
          like: "searchType",
          value: "value"
        };
      }
    },
    leftWidth: {
      type: Number,
      "default": 90
    },
    rightWidth: {
      type: Number,
      "default": 160
    },
    noEmpty: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update:modelValue", "change-object", "change"],
  setup: function setup9(props, _ref) {
    var emit = _ref.emit;
    var key = ref("");
    var like = ref("");
    var value = ref("");
    onMounted(function() {
      key.value = props.modelValue[props.config.key];
      like.value = props.modelValue[props.config.like];
      value.value = props.modelValue[props.config.value];
    });
    watch(function() {
      return props.modelValue[props.config.key];
    }, function(newVal) {
      key.value = newVal;
      var element = props.options.find(function(v) {
        return v[props.valueKey] === newVal;
      });
      if (element && element["default"] >= 0) {
        like.value = element["default"];
      }
      if (props.noEmpty)
        return;
      value.value = "";
    });
    watch(function() {
      return props.modelValue[props.config.like];
    }, function(newVal) {
      like.value = newVal;
    });
    watch(function() {
      return props.modelValue[props.config.value];
    }, function(newVal) {
      value.value = newVal;
    });
    watch(key, function(newVal) {
      var data = props.modelValue;
      data[props.config.key] = newVal;
      emit("update:modelValue", data);
    });
    watch(like, function(newVal) {
      var data = props.modelValue;
      data[props.config.like] = newVal;
      emit("update:modelValue", data);
    });
    watch(value, function(newVal) {
      var data = props.modelValue;
      data[props.config.value] = newVal;
      emit("update:modelValue", data);
    });
    var handleKeyChange = function handleKeyChange2(val) {
      emit("change", {
        key: val
      });
      if (props.options && props.options.length > 0) {
        var _emit;
        emit("change-object", (_emit = {}, _defineProperty$1(_emit, props.config.key, toRaw(props.options).find(function(v) {
          return v[props.valueKey] === val;
        })), _defineProperty$1(_emit, props.config.like, toRaw(props.likeOptions).find(function(v) {
          return v.value === props.modelValue[props.config.like];
        })), _defineProperty$1(_emit, props.config.value, props.modelValue[props.config.value]), _emit));
      }
    };
    var handleLikeChange = function handleLikeChange2(val) {
      emit("change", {
        like: val
      });
      if (props.options && props.options.length > 0) {
        var _emit2;
        emit("change-object", (_emit2 = {}, _defineProperty$1(_emit2, props.config.key, toRaw(props.options).find(function(v) {
          return v[props.valueKey] === props.modelValue[props.config.key];
        })), _defineProperty$1(_emit2, props.config.like, toRaw(props.likeOptions).find(function(v) {
          return v.value === val;
        })), _defineProperty$1(_emit2, props.config.value, props.modelValue[props.config.value]), _emit2));
      }
    };
    var handleInputChange = function handleInputChange2(val) {
      emit("change", {
        value: val
      });
      if (props.options && props.options.length > 0) {
        var _emit3;
        emit("change-object", (_emit3 = {}, _defineProperty$1(_emit3, props.config.key, toRaw(props.options).find(function(v) {
          return v[props.valueKey] === props.modelValue[props.config.key];
        })), _defineProperty$1(_emit3, props.config.like, toRaw(props.likeOptions).find(function(v) {
          return v.value === props.modelValue[props.config.like];
        })), _defineProperty$1(_emit3, props.config.value, val), _emit3));
      }
    };
    var isFocusLike = ref(false);
    var isFocus = ref(false);
    return {
      key,
      like,
      value,
      isFocus,
      isFocusLike,
      handleKeyChange,
      handleLikeChange,
      handleInputChange
    };
  }
};
var _hoisted_1$s = {
  "class": "gj-select-like-input"
};
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_option = resolveComponent("gj-option");
  var _component_gj_select = resolveComponent("gj-select");
  var _component_gj_input = resolveComponent("gj-input");
  return openBlock(), createElementBlock("div", _hoisted_1$s, [createVNode(_component_gj_select, {
    modelValue: $setup.key,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
      return $setup.key = $event;
    }),
    style: normalizeStyle({
      "width": $props.leftWidth + "px",
      zIndex: $setup.isFocus && 10
    }),
    clearable: false,
    "class": "gj-select__key",
    onBlur: _cache[1] || (_cache[1] = function($event) {
      return $setup.isFocus = false;
    }),
    onFocus: _cache[2] || (_cache[2] = function($event) {
      return $setup.isFocus = true;
    }),
    onChange: $setup.handleKeyChange
  }, {
    "default": withCtx(function() {
      return [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, function(item) {
        return openBlock(), createBlock(_component_gj_option, {
          key: item[$props.valueKey],
          label: item[$props.labelKey],
          value: item[$props.valueKey]
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "style", "onChange"]), createVNode(_component_gj_select, {
    modelValue: $setup.like,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function($event) {
      return $setup.like = $event;
    }),
    clearable: false,
    "class": "gj-select__like",
    style: normalizeStyle({
      zIndex: $setup.isFocusLike && 10
    }),
    onChange: $setup.handleLikeChange,
    onBlur: _cache[4] || (_cache[4] = function($event) {
      return $setup.isFocusLike = false;
    }),
    onFocus: _cache[5] || (_cache[5] = function($event) {
      return $setup.isFocusLike = true;
    })
  }, {
    "default": withCtx(function() {
      return [(openBlock(true), createElementBlock(Fragment, null, renderList($props.likeOptions, function(item) {
        return openBlock(), createBlock(_component_gj_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "style", "onChange"]), createVNode(_component_gj_input, mergeProps(_ctx.$attrs, {
    ref: "inputRef",
    modelValue: $setup.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function($event) {
      return $setup.value = $event;
    }),
    style: {
      "width": $props.rightWidth + "px"
    },
    "class": "gj-select__input",
    clearable: "",
    onChange: $setup.handleInputChange
  }), createSlots({
    _: 2
  }, [_ctx.$slots.suffix ? {
    name: "suffix",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "suffix")];
    })
  } : void 0, _ctx.$slots.prefix ? {
    name: "prefix",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "prefix")];
    })
  } : void 0]), 1040, ["modelValue", "style", "onChange"])]);
}
_sfc_main$U.render = _sfc_render$T;
var GjSelectComposeDatePicker = withInstall(_sfc_main$W, {
  selectLikeInput: _sfc_main$U
});
var GjSelectLikeInput = withNoopInstall(_sfc_main$U);
var GjDatePicker = withInstall(_sfc_main$X);
var GjDivider = withInstall(_sfc_main$15);
var _sfc_main$T = {
  name: "GjDropdown"
};
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_dropdown_menu = resolveComponent("el-dropdown-menu");
  var _component_el_dropdown = resolveComponent("el-dropdown");
  return openBlock(), createBlock(_component_el_dropdown, mergeProps(_ctx.$attrs, {
    "class": "gj-dropdown",
    placement: "bottom-start"
  }), {
    dropdown: withCtx(function() {
      return [createVNode(_component_el_dropdown_menu, null, {
        "default": withCtx(function() {
          return [renderSlot(_ctx.$slots, "dropdown")];
        }),
        _: 3
      })];
    }),
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$T.render = _sfc_render$S;
var _sfc_main$S = {
  name: "GjDropdownItem"
};
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_dropdown_item = resolveComponent("el-dropdown-item");
  return openBlock(), createBlock(_component_el_dropdown_item, mergeProps(_ctx.$attrs, {
    "class": "gj-dropdown-item"
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$S.render = _sfc_render$R;
var _sfc_main$R = {
  name: "GjDropdownOp",
  props: {
    config: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      "default": 2
    }
  },
  emits: ["click"],
  setup: function setup10(props, _ref) {
    var emit = _ref.emit;
    var showConfig = computed(function() {
      return props.config.filter(function(v) {
        return typeof v.show === "function" ? v.show() : v.show;
      });
    });
    var textBtnConfig = computed(function() {
      return showConfig.value.slice(0, props.max);
    });
    var dropdownConfig = computed(function() {
      return showConfig.value.slice(props.max, showConfig.value.length);
    });
    var handleCommand = function handleCommand2(item) {
      if (item.click && typeof item.click === "function") {
        item.click();
      }
      emit("click", item);
    };
    return {
      textBtnConfig,
      dropdownConfig,
      handleCommand
    };
  }
};
var _hoisted_1$r = {
  "class": "gj-dropdown-op"
};
var _hoisted_2$k = {
  "class": "gj-dropdown-op-icon"
};
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_button = resolveComponent("gj-button");
  var _component_gj_dropdown_item = resolveComponent("gj-dropdown-item");
  var _component_gj_dropdown = resolveComponent("gj-dropdown");
  return openBlock(), createElementBlock("div", _hoisted_1$r, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.textBtnConfig, function(item) {
    return openBlock(), createBlock(_component_gj_button, {
      key: item.label,
      type: "text",
      onClick: function onClick($event) {
        return $setup.handleCommand(item);
      }
    }, {
      "default": withCtx(function() {
        return [createTextVNode(toDisplayString(item.label), 1)];
      }),
      _: 2
    }, 1032, ["onClick"]);
  }), 128)), $setup.dropdownConfig.length > 0 ? (openBlock(), createBlock(_component_gj_dropdown, {
    key: 0,
    placement: "bottom-end"
  }, {
    "default": withCtx(function() {
      return [createElementVNode("div", _hoisted_2$k, [(openBlock(), createElementBlock(Fragment, null, renderList(3, function(item) {
        return createElementVNode("span", {
          key: item
        });
      }), 64))])];
    }),
    dropdown: withCtx(function() {
      return [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.dropdownConfig, function(item) {
        return openBlock(), createBlock(_component_gj_dropdown_item, {
          key: item.label,
          onClick: function onClick($event) {
            return $setup.handleCommand(item);
          }
        }, {
          "default": withCtx(function() {
            return [createTextVNode(toDisplayString(item.label), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  })) : createCommentVNode("", true)]);
}
_sfc_main$R.render = _sfc_render$Q;
var GjDropdown = withInstall(_sfc_main$T, {
  dropdownItem: _sfc_main$S,
  dropdownOP: _sfc_main$R
});
var GjDropdownItem = withNoopInstall(_sfc_main$S);
var GjDropdownOp = withNoopInstall(_sfc_main$R);
var GjFilterGroup = withInstall(_sfc_main$_);
var _sfc_main$Q = {
  name: "GjForm",
  setup: function setup11() {
    var formRef = ref(null);
    var validate = ref(null);
    var resetFields = ref(null);
    onMounted(function() {
      validate.value = formRef.value.validate;
      resetFields.value = formRef.value.resetFields;
    });
    return {
      formRef,
      validate,
      resetFields
    };
  }
};
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_form = resolveComponent("el-form");
  return openBlock(), createBlock(_component_el_form, mergeProps(_ctx.$attrs, {
    ref: "formRef",
    "class": "gj-form",
    onSubmit: _cache[0] || (_cache[0] = withModifiers(function() {
    }, ["prevent"]))
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$Q.render = _sfc_render$P;
var _sfc_main$P = {
  name: "GjFormItem",
  setup: function setup12() {
    var formItemRef = ref(null);
    var clearValidate = ref(null);
    var resetField = ref(null);
    onMounted(function() {
      clearValidate.value = formItemRef.value.clearValidate;
      resetField.value = formItemRef.value.resetFields;
    });
    return {
      formItemRef,
      clearValidate,
      resetField
    };
  }
};
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_form_item = resolveComponent("el-form-item");
  return openBlock(), createBlock(_component_el_form_item, mergeProps(_ctx.$attrs, {
    ref: "formItemRef"
  }), createSlots({
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 2
  }, [_ctx.$slots.error ? {
    name: "error",
    fn: withCtx(function(_ref) {
      var error = _ref.error;
      return [renderSlot(_ctx.$slots, "error", {
        error
      })];
    })
  } : void 0, _ctx.$slots.label ? {
    name: "label",
    fn: withCtx(function(_ref2) {
      var label = _ref2.label;
      return [renderSlot(_ctx.$slots, "label", {
        label
      })];
    })
  } : void 0]), 1040);
}
_sfc_main$P.render = _sfc_render$O;
var GjForm = withInstall(_sfc_main$Q, {
  formItem: _sfc_main$P
});
var GjFormItem = withNoopInstall(_sfc_main$P);
var _sfc_main$O = {
  name: "GjSvgIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      "default": "#666"
    },
    size: {
      type: Number,
      "default": 24
    }
  },
  setup: function setup13(props) {
    var symbolId = computed(function() {
      return "#gj-icon-".concat(props.name);
    });
    var style = computed(function() {
      return {
        width: props.size + "px",
        height: props.size + "px"
      };
    });
    return {
      symbolId,
      style
    };
  }
};
var _hoisted_1$q = ["xlink:href", "fill"];
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    "aria-hidden": "true",
    "class": "gj-svg-icon",
    style: normalizeStyle($setup.style)
  }, [createElementVNode("use", {
    "xlink:href": $setup.symbolId,
    fill: $props.color
  }, null, 8, _hoisted_1$q)], 4);
}
_sfc_main$O.render = _sfc_render$N;
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length = values.length, offset = array.length;
      while (++index2 < length) {
        array[offset + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view2 = getView(0, arrLength, this.__views__), start = view2.start, end = view2.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed2 = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed2;
              } else if (!computed2) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed2) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed2, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed2 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed2))) {
            var computed2 = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed2) : includes2(result2, computed2, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed2) : includes2(arrays[othIndex], computed2, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path = paths[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed2, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n) {
        var result2 = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n % 2) {
            result2 += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed2 = array[mid];
            if (computed2 !== null && !isSymbol(computed2) && (retHighest ? computed2 <= value : computed2 < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed2 = iteratee2(array[mid]), othIsDefined = computed2 !== undefined$1, othIsNull = computed2 === null, othIsReflexive = computed2 === computed2, othIsSymbol = isSymbol(computed2);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed2 <= value : computed2 < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed2, seen)) {
            var seen = computed2;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed2) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed2);
              }
              result2.push(value);
            } else if (!includes2(seen, computed2, comparator)) {
              if (seen !== result2) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result2).set(new Uint8Array(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index2 = -1, length = source.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length);
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function(values2) {
        return new Set(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data = map2.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop3(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find2 = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle2(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
      }
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }
      function replace() {
        var args = arguments, string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches2(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index2 < n) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop3;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches2;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle2;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find2;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer;
      lodash2.isDate = isDate;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite;
      lodash2.isFunction = isFunction;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber;
      lodash2.isObject = isObject;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule) {
      (freeModule.exports = _2)._ = _2;
      freeExports._ = _2;
    } else {
      root._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var _ = lodash.exports;
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var _sfc_main$N = {
  name: "GjIcon",
  inheritAttrs: false,
  props: {
    size: {
      type: String || Number
    },
    color: {
      type: String
    }
  },
  setup: function setup14(props) {
    return {
      style: computed(function() {
        if (!props.size && !props.color) {
          return {};
        }
        var size = props.size;
        if (lodash.exports.isNumber(size) || lodash.exports.isString(size) && !size.endsWith("px")) {
          size = "".concat(size, "px");
        }
        return _objectSpread$4(_objectSpread$4({}, props.size ? {
          "--font-size": size
        } : {}), props.color ? {
          "--color": props.color
        } : {});
      })
    };
  }
};
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", mergeProps({
    "class": "gj-icon",
    style: $setup.style
  }, _ctx.$attrs), [renderSlot(_ctx.$slots, "default")], 16);
}
_sfc_main$N.render = _sfc_render$M;
var GjSvgIcon = withInstall(_sfc_main$O);
var GjIcon = withInstall(_sfc_main$N);
var sizes$2 = ["xs", "s", "m", "l", "xl"];
var _sfc_main$M = {
  name: "GjImage",
  props: {
    fit: {
      type: String,
      "default": "",
      validator: function validator6(t) {
        return ["", "contain", "cover", "fill", "none", "scale-down"].includes(t);
      }
    },
    size: {
      type: String,
      "default": "m",
      validator: function validator7(v) {
        return sizes$2.includes(v);
      }
    },
    src: {
      type: String,
      required: true
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  emits: ["error"],
  setup: function setup15(props, _ref) {
    var emit = _ref.emit;
    var loading = ref(false);
    var hasLoadError = ref(false);
    var loadImage = function loadImage2() {
      loading.value = true;
      hasLoadError.value = false;
      var img = new Image();
      img.addEventListener("load", function(e) {
        return handleLoad();
      });
      img.addEventListener("error", handleError);
      img.src = props.src;
    };
    function handleLoad(e, img) {
      loading.value = false;
      hasLoadError.value = false;
    }
    function handleError(event) {
      loading.value = false;
      hasLoadError.value = true;
      emit("error", event);
    }
    onMounted(function() {
      loadImage();
    });
    watch(function() {
      return props.src;
    }, function() {
      loadImage();
    });
    var style = computed(function() {
      var sizeValues = [40, 60, 80, 120, 200];
      if (props.width && props.height) {
        return {
          width: props.width + "px",
          height: props.height + "px"
        };
      } else {
        var length = sizeValues[sizes$2.findIndex(function(v) {
          return v === props.size;
        })];
        return {
          width: length + "px",
          height: length + "px"
        };
      }
    });
    return {
      style,
      loading,
      hasLoadError
    };
  }
};
var _hoisted_1$p = {
  key: 1,
  "class": "gj-image-fail"
};
var _hoisted_2$j = /* @__PURE__ */ createElementVNode("i", {
  "class": "el-icon-picture-outline"
}, null, -1);
var _hoisted_3$h = [_hoisted_2$j];
var _hoisted_4$9 = ["src"];
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": "gj-image",
    style: normalizeStyle($setup.style)
  }, [$setup.loading ? renderSlot(_ctx.$slots, "placeholder", {
    key: 0
  }) : $setup.hasLoadError ? (openBlock(), createElementBlock("div", _hoisted_1$p, _hoisted_3$h)) : (openBlock(), createElementBlock("img", {
    key: 2,
    src: $props.src,
    alt: "/",
    style: normalizeStyle({
      objectFit: $props.fit
    })
  }, null, 12, _hoisted_4$9))], 4);
}
_sfc_main$M.render = _sfc_render$L;
var GjImage = withInstall(_sfc_main$M);
var _sfc_main$L = {
  name: "GjInputAffix",
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
var _hoisted_1$o = {
  "class": "gj-input-affix"
};
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$o, toDisplayString($props.text), 1);
}
_sfc_main$L.render = _sfc_render$K;
var _sfc_main$K = {};
var _hoisted_1$n = {
  "class": "gj-icon__more"
};
var _hoisted_2$i = /* @__PURE__ */ createElementVNode("span", null, null, -1);
var _hoisted_3$g = /* @__PURE__ */ createElementVNode("span", null, null, -1);
var _hoisted_4$8 = /* @__PURE__ */ createElementVNode("span", null, null, -1);
function _sfc_render$J(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$n, [_hoisted_2$i, _hoisted_3$g, _hoisted_4$8, renderSlot(_ctx.$slots, "default")]);
}
_sfc_main$K.render = _sfc_render$J;
var _sfc_main$J = {
  name: "GjInputSearchMore",
  components: {
    GjInput: _sfc_main$V,
    iconMore: _sfc_main$K
  },
  props: {
    modelValue: {
      type: String,
      required: true
    },
    morePlaceholder: {
      type: String,
      "default": "\u4E00\u884C\u4E00\u9879\uFF0C\u6700\u591A\u8F93\u5165200\u884C"
    },
    disabledRows: {
      type: Number,
      "default": 200
    }
  },
  emits: ["update:modelValue", "change"],
  setup: function setup16(props, _ref) {
    var emit = _ref.emit;
    var text = ref("");
    var visible = ref(false);
    var showValue = ref("");
    var setShowValue = function setShowValue2() {
      showValue.value = props.modelValue;
    };
    var _useLocale = useLocale(), t = _useLocale.t;
    onMounted(function() {
      setShowValue();
    });
    watch(function() {
      return props.modelValue;
    }, function() {
      setShowValue();
    });
    watch(visible, function(value) {
      if (value) {
        text.value = props.modelValue ? props.modelValue.split(",").filter(function(v) {
          return v !== "";
        }).join("\n") : "";
      }
    });
    var handleInput = function handleInput2(val) {
      emit("update:modelValue", val);
    };
    var handleReset = function handleReset2() {
      text.value = "";
      emit("change", []);
      emit("update:modelValue", "");
    };
    var handleSubmit = function handleSubmit2() {
      var str = text.value.split("\n").filter(function(v) {
        return v !== "";
      }).slice(0, props.disabledRows).join(",");
      emit("update:modelValue", str);
      emit("change", str.split(","));
      visible.value = !visible.value;
    };
    var handleChange = function handleChange2(val) {
      emit("change", val.split(","));
    };
    return {
      t,
      text,
      visible,
      showValue,
      handleInput,
      handleReset,
      handleSubmit,
      handleChange,
      disabled: computed(function() {
        return text.value.split("\n").length > props.disabledRows;
      })
    };
  }
};
var _hoisted_1$m = {
  "class": "search-more--popover"
};
var _hoisted_2$h = {
  "class": "search-more--popover-bottom"
};
var _hoisted_3$f = {
  "class": "search-more--popover-bottom-right"
};
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_icon_more = resolveComponent("icon-more");
  var _component_el_input = resolveComponent("el-input");
  var _component_gj_button = resolveComponent("gj-button");
  var _component_el_popover = resolveComponent("el-popover");
  var _component_gj_input = resolveComponent("gj-input");
  return openBlock(), createBlock(_component_gj_input, mergeProps({
    modelValue: $setup.showValue,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function($event) {
      return $setup.showValue = $event;
    })
  }, _ctx.$attrs, {
    clearable: "",
    "class": "gj-input--search-more",
    onChange: $setup.handleChange,
    onInput: $setup.handleInput
  }), {
    append: withCtx(function() {
      return [createVNode(_component_el_popover, {
        visible: $setup.visible,
        "onUpdate:visible": _cache[3] || (_cache[3] = function($event) {
          return $setup.visible = $event;
        }),
        trigger: "click",
        placement: "bottom",
        width: 260
      }, {
        reference: withCtx(function() {
          return [createVNode(_component_icon_more, {
            onClick: _cache[0] || (_cache[0] = function($event) {
              return $setup.visible = !$setup.visible;
            })
          })];
        }),
        "default": withCtx(function() {
          return [createElementVNode("div", _hoisted_1$m, [createVNode(_component_el_input, {
            modelValue: $setup.text,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function($event) {
              return $setup.text = $event;
            }),
            placeholder: $props.morePlaceholder,
            disabled: $setup.disabled,
            type: "textarea",
            rows: "8"
          }, null, 8, ["modelValue", "placeholder", "disabled"]), createElementVNode("div", _hoisted_2$h, [createVNode(_component_gj_button, {
            size: "mini",
            onClick: $setup.handleReset
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.resetButtonText")), 1)];
            }),
            _: 1
          }, 8, ["onClick"]), createElementVNode("div", _hoisted_3$f, [createVNode(_component_gj_button, {
            type: "primary",
            plain: "",
            size: "mini",
            onClick: _cache[2] || (_cache[2] = function($event) {
              return $setup.visible = !$setup.visible;
            })
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.cancelButtonText")), 1)];
            }),
            _: 1
          }), createVNode(_component_gj_button, {
            type: "primary",
            size: "mini",
            onClick: $setup.handleSubmit
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.confirmButtonText")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])])])])];
        }),
        _: 1
      }, 8, ["visible"])];
    }),
    _: 1
  }, 16, ["modelValue", "onChange", "onInput"]);
}
_sfc_main$J.render = _sfc_render$I;
function useMore(showValue, opt, callback) {
  var visible = ref(false);
  var text = ref("");
  watch(visible, function(value) {
    if (value) {
      text.value = showValue.value ? showValue.value.split(",").filter(function(v) {
        return v !== "";
      }).join("\n") : "";
    }
  });
  var handleReset = function handleReset2() {
    text.value = "";
    showValue.value = "";
    callback();
  };
  var handleSubmit = function handleSubmit2() {
    showValue.value = text.value.split("\n").filter(function(v) {
      return v !== "";
    }).join(",");
    callback(showValue.value);
    visible.value = !visible.value;
  };
  return {
    visible,
    text,
    disabled: computed(function() {
      return text.value.split("\n").length > opt.rows;
    }),
    handleReset,
    handleSubmit
  };
}
var defaultConfig = {
  key: "key",
  value: "value",
  mode: null,
  placeholder: "\u4E00\u884C\u4E00\u9879\uFF0C\u6700\u591A\u8F93\u5165200\u884C",
  rows: 200
};
var _sfc_main$I = {
  name: "GjInputComposeSelect",
  components: {
    gjFilterGroup: _sfc_main$_,
    gjSelect: _sfc_main$Z,
    gjOption: _sfc_main$Y,
    iconMore: _sfc_main$K
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true,
      "default": function _default8() {
        return [];
      }
    },
    labelKey: {
      type: String,
      "default": "text"
    },
    valueKey: {
      type: String,
      "default": "id"
    },
    config: {
      type: Object
    },
    leftWidth: {
      type: Number,
      "default": 90
    },
    rightWidth: {
      type: Number,
      "default": 160
    },
    noEmpty: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update:modelValue", "change-object", "change", "inputChange"],
  setup: function setup17(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var opt = computed(function() {
      var _props$config, _props$config2, _props$config3, _props$config4, _props$config5;
      return {
        key: ((_props$config = props.config) === null || _props$config === void 0 ? void 0 : _props$config.key) || defaultConfig.key,
        value: ((_props$config2 = props.config) === null || _props$config2 === void 0 ? void 0 : _props$config2.value) || defaultConfig.value,
        mode: ((_props$config3 = props.config) === null || _props$config3 === void 0 ? void 0 : _props$config3.mode) || defaultConfig.mode,
        placeholder: ((_props$config4 = props.config) === null || _props$config4 === void 0 ? void 0 : _props$config4.placeholder) || defaultConfig.placeholder,
        rows: ((_props$config5 = props.config) === null || _props$config5 === void 0 ? void 0 : _props$config5.rows) || defaultConfig.rows
      };
    });
    var key = ref("");
    var value = ref("");
    onMounted(function() {
      key.value = props.modelValue[opt.value.key];
      value.value = props.modelValue[opt.value.value];
    });
    watch(function() {
      return props.modelValue[opt.value.key];
    }, function(newVal) {
      key.value = newVal;
      if (props.noEmpty)
        return;
      value.value = "";
    });
    watch(function() {
      return props.modelValue[opt.value.value];
    }, function(newVal) {
      value.value = newVal;
    });
    watch(key, function() {
      var data = props.modelValue;
      data[opt.value.key] = key.value;
      emit("update:modelValue", data);
    });
    watch(value, function() {
      var data = props.modelValue;
      data[opt.value.value] = value.value;
      emit("update:modelValue", data);
    });
    var callback = function callback2(val) {
      var _emit;
      emit("change-object", (_emit = {}, _defineProperty$1(_emit, opt.value.key, toRaw(props.options).find(function(v) {
        return v[props.valueKey] === props.modelValue[opt.value.key];
      })), _defineProperty$1(_emit, opt.value.value, val || ""), _emit));
    };
    var _useMore = useMore(value, opt, callback), visible = _useMore.visible, text = _useMore.text, handleReset = _useMore.handleReset, handleSubmit = _useMore.handleSubmit, disabled = _useMore.disabled;
    var handleChange = function handleChange2(val) {
      emit("change", val);
      if (props.options && props.options.length > 0) {
        var _emit2;
        emit("change-object", (_emit2 = {}, _defineProperty$1(_emit2, opt.value.key, toRaw(props.options).find(function(v) {
          return v[props.valueKey] === val;
        })), _defineProperty$1(_emit2, opt.value.value, props.modelValue[opt.value.value]), _emit2));
      }
    };
    var handleInputChange = function handleInputChange2(val) {
      var _emit3;
      emit("inputChange", val);
      emit("change-object", (_emit3 = {}, _defineProperty$1(_emit3, opt.value.key, toRaw(props.options).find(function(v) {
        return v[props.valueKey] === props.modelValue[opt.value.key];
      })), _defineProperty$1(_emit3, opt.value.value, val), _emit3));
    };
    return {
      t,
      value,
      key,
      visible,
      text,
      opt,
      disabled,
      handleChange,
      handleInputChange,
      handleReset,
      handleSubmit
    };
  }
};
var _hoisted_1$l = {
  "class": "search-more--popover"
};
var _hoisted_2$g = {
  "class": "search-more--popover-bottom"
};
var _hoisted_3$e = {
  "class": "search-more--popover-bottom-right"
};
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_option = resolveComponent("gj-option");
  var _component_gj_select = resolveComponent("gj-select");
  var _component_icon_more = resolveComponent("icon-more");
  var _component_el_input = resolveComponent("el-input");
  var _component_gj_button = resolveComponent("gj-button");
  var _component_el_popover = resolveComponent("el-popover");
  var _component_gj_filter_group = resolveComponent("gj-filter-group");
  return openBlock(), createBlock(_component_gj_filter_group, null, {
    "default": withCtx(function() {
      return [createVNode(_component_gj_select, {
        modelValue: $setup.key,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
          return $setup.key = $event;
        }),
        style: normalizeStyle({
          "width": $props.leftWidth + "px"
        }),
        clearable: false,
        onChange: $setup.handleChange
      }, {
        "default": withCtx(function() {
          return [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, function(item) {
            return openBlock(), createBlock(_component_gj_option, {
              key: item[$props.valueKey],
              label: item[$props.labelKey],
              value: item[$props.valueKey]
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue", "style", "onChange"]), createVNode(_component_el_input, mergeProps(_ctx.$attrs, {
        ref: "inputRef",
        modelValue: $setup.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function($event) {
          return $setup.value = $event;
        }),
        clearable: "",
        style: {
          "width": $props.rightWidth + "px"
        },
        "class": ["gj-input", "gj-input--search-more"],
        onChange: $setup.handleInputChange
      }), createSlots({
        append: withCtx(function() {
          return [$setup.opt.mode === "more" ? (openBlock(), createBlock(_component_el_popover, {
            key: 0,
            visible: $setup.visible,
            "onUpdate:visible": _cache[4] || (_cache[4] = function($event) {
              return $setup.visible = $event;
            }),
            trigger: "click",
            placement: "bottom",
            width: 260
          }, {
            reference: withCtx(function() {
              return [createVNode(_component_icon_more, {
                onClick: _cache[1] || (_cache[1] = function($event) {
                  return $setup.visible = !$setup.visible;
                })
              })];
            }),
            "default": withCtx(function() {
              return [createElementVNode("div", _hoisted_1$l, [createVNode(_component_el_input, {
                modelValue: $setup.text,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function($event) {
                  return $setup.text = $event;
                }),
                disabled: $setup.disabled,
                placeholder: $setup.opt.placeholder,
                type: "textarea",
                "class": "gj-textarea",
                rows: "8"
              }, null, 8, ["modelValue", "disabled", "placeholder"]), createElementVNode("div", _hoisted_2$g, [createVNode(_component_gj_button, {
                size: "mini",
                onClick: $setup.handleReset
              }, {
                "default": withCtx(function() {
                  return [createTextVNode(toDisplayString($setup.t("gj.search.resetButtonText")), 1)];
                }),
                _: 1
              }, 8, ["onClick"]), createElementVNode("div", _hoisted_3$e, [createVNode(_component_gj_button, {
                type: "primary",
                plain: "",
                size: "mini",
                onClick: _cache[3] || (_cache[3] = function($event) {
                  return $setup.visible = !$setup.visible;
                })
              }, {
                "default": withCtx(function() {
                  return [createTextVNode(toDisplayString($setup.t("gj.search.cancelButtonText")), 1)];
                }),
                _: 1
              }), createVNode(_component_gj_button, {
                type: "primary",
                size: "mini",
                onClick: $setup.handleSubmit
              }, {
                "default": withCtx(function() {
                  return [createTextVNode(toDisplayString($setup.t("gj.search.confirmButtonText")), 1)];
                }),
                _: 1
              }, 8, ["onClick"])])])])];
            }),
            _: 1
          }, 8, ["visible"])) : renderSlot(_ctx.$slots, "append", {
            key: 1
          })];
        }),
        _: 2
      }, [_ctx.$slots.suffix ? {
        name: "suffix",
        fn: withCtx(function() {
          return [renderSlot(_ctx.$slots, "suffix")];
        })
      } : void 0, _ctx.$slots.prefix ? {
        name: "prefix",
        fn: withCtx(function() {
          return [renderSlot(_ctx.$slots, "prefix")];
        })
      } : void 0, _ctx.$slots.prepend ? {
        name: "prepend",
        fn: withCtx(function() {
          return [renderSlot(_ctx.$slots, "prepend")];
        })
      } : void 0]), 1040, ["modelValue", "style", "onChange"])];
    }),
    _: 3
  });
}
_sfc_main$I.render = _sfc_render$H;
var GjInput = withInstall(_sfc_main$V, {
  inputAffix: _sfc_main$L,
  inputSearchMore: _sfc_main$J,
  inputComposeSelect: _sfc_main$I
});
var GjInputAffix = withNoopInstall(_sfc_main$L);
var GjInputSearchMore = withNoopInstall(_sfc_main$J);
var GjInputComposeSelect = withNoopInstall(_sfc_main$I);
var _sfc_main$H = {
  name: "GjPagination",
  components: {
    ElPagination
  },
  props: {
    background: {
      type: Boolean,
      "default": false
    }
  }
};
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_pagination = resolveComponent("el-pagination");
  return openBlock(), createBlock(_component_el_pagination, mergeProps(_ctx.$attrs, {
    background: $props.background,
    "pager-count": 5,
    "page-sizes": [20, 50, 100, 200, 500],
    "class": [$props.background && "gj-hoverClass", "gj-pagination"]
  }), null, 16, ["background", "class"]);
}
_sfc_main$H.render = _sfc_render$G;
var GjPagination = withInstall(_sfc_main$H);
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var sizes$1 = ["big", "medium", "small", "mini"];
var _sfc_main$G = {
  name: "GjPopUp",
  components: {
    gjButton: _sfc_main$12
  },
  props: {
    appendToBody: {
      type: Boolean,
      "default": false
    },
    modelValue: Boolean,
    title: String,
    size: {
      type: String,
      "default": "medium",
      validator: function validator8(t) {
        return sizes$1.includes(t);
      }
    },
    to: {
      type: String
    },
    width: Number,
    fullScreen: Boolean,
    isFooter: {
      type: Boolean,
      "default": false
    },
    cancelButtonText: String,
    confirmButtonText: String,
    loading: {
      type: Boolean,
      "default": false
    },
    loadingText: {
      type: String,
      "default": null
    },
    confirmLoading: {
      type: Boolean,
      "default": false
    },
    padding: {
      type: [Number, Array],
      "default": 16
    },
    zIndex: {
      type: Number
    },
    titleClass: {
      type: String
    },
    bodyClass: {
      type: String
    }
  },
  emits: ["update:modelValue", "confirm", "close"],
  setup: function setup18(props, _ref) {
    var emit = _ref.emit;
    _ref.slots;
    var _useLocale = useLocale(), t = _useLocale.t;
    var clientWidth = ref(0);
    var $GPLUS = useGlobalConfig();
    var currentIndex = ref(props.zIndex ? props.zIndex : PopupManager.nextZIndex());
    watch(function() {
      return [props.width, props.size];
    }, function(_ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 2), newWidth = _ref4[0], newSize = _ref4[1];
      var _ref5 = _slicedToArray(_ref3, 2);
      _ref5[0];
      _ref5[1];
      if (newWidth) {
        clientWidth.value = props.width;
      } else {
        var widths = [1e3, 800, 600, 400];
        clientWidth.value = widths[sizes$1.findIndex(function(v) {
          return v === newSize;
        })];
      }
    });
    onMounted(function() {
      if (props.width) {
        clientWidth.value = props.width;
      } else {
        var widths = [1e3, 800, 600, 400];
        clientWidth.value = widths[sizes$1.findIndex(function(v) {
          return v === props.size;
        })];
      }
    });
    var style = computed(function() {
      if (props.fullScreen) {
        return {
          width: "calc(100% - 40px)",
          height: "calc(100% - 24px)"
        };
      } else {
        return {
          width: clientWidth.value + "px"
        };
      }
    });
    var bodyStyle = computed(function() {
      var style2 = {};
      if (typeof props.padding === "number") {
        style2.padding = "".concat(props.padding, "px");
      }
      if (Array.isArray(props.padding)) {
        style2.padding = props.padding.map(function(v) {
          return "".concat(v, "px");
        }).join(" ");
      }
      if (props.isFooter) {
        if (props.fullScreen) {
          style2.height = "calc(100% - 104px)";
        } else {
          style2.maxHeight = "calc(100% - 104px)";
        }
      } else {
        if (props.fullScreen) {
          style2.height = "calc(100% - 40px)";
        } else {
          style2.maxHeight = "calc(100% - 40px)";
        }
      }
      return style2;
    });
    var handleCancel = function handleCancel2(val) {
      emit("close", val);
      emit("update:modelValue", false);
    };
    var handleConfirm = function handleConfirm2() {
      emit("confirm");
    };
    provide("closePopUp", handleCancel);
    var realTo = computed(function() {
      var to = props.to || $GPLUS.modalTo || "body";
      var isArray2 = Array.isArray(to);
      var hasEl;
      var index2;
      if (isArray2) {
        hasEl = to.some(function(e, i) {
          var find2 = document.querySelector(e || null);
          if (find2)
            index2 = i;
          return find2;
        });
      } else {
        hasEl = document.querySelector(to);
      }
      if (!hasEl)
        console.warn("\u76EE\u6807\u5143\u7D20\u4E0D\u5B58\u5728,\u5DF2\u6302\u8F7D\u6839\u5143\u7D20body");
      return hasEl ? isArray2 ? to[index2] : to : "body";
    });
    return {
      t,
      handleCancel,
      handleConfirm,
      style,
      bodyStyle,
      realTo,
      currentIndex
    };
  }
};
var _hoisted_1$k = {
  "class": "gj-dialog-title-left"
};
var _hoisted_2$f = {
  "class": "gj-pop-up-title"
};
var _hoisted_3$d = /* @__PURE__ */ createElementVNode("i", {
  "class": "el-icon-close"
}, null, -1);
var _hoisted_4$7 = [_hoisted_3$d];
var _hoisted_5$4 = ["element-loading-text"];
var _hoisted_6$2 = {
  key: 0,
  "class": "gj-dialog-footer"
};
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_button = resolveComponent("gj-button");
  var _directive_loading = resolveDirective("loading");
  return openBlock(), createBlock(Teleport, {
    to: $setup.realTo,
    disabled: !$props.appendToBody
  }, [createVNode(Transition, {
    name: "el-fade-in-linear"
  }, {
    "default": withCtx(function() {
      return [$props.modelValue ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": "gj-mark",
        style: normalizeStyle({
          zIndex: $setup.currentIndex
        })
      }, [createElementVNode("div", {
        "class": "gj-dialog-content",
        style: normalizeStyle($setup.style)
      }, [createElementVNode("div", {
        "class": normalizeClass(["gj-dialog-title", $props.titleClass])
      }, [createElementVNode("div", _hoisted_1$k, [createElementVNode("span", _hoisted_2$f, toDisplayString($props.title), 1), renderSlot(_ctx.$slots, "title-extra")]), createElementVNode("span", {
        "class": "gj-pop-up-icon",
        onClick: _cache[0] || (_cache[0] = function() {
          return $setup.handleCancel && $setup.handleCancel.apply($setup, arguments);
        })
      }, _hoisted_4$7)], 2), withDirectives(createElementVNode("div", {
        "class": normalizeClass(["gj-dialog-body", $props.bodyClass]),
        style: normalizeStyle($setup.bodyStyle),
        "element-loading-text": $props.loadingText
      }, [renderSlot(_ctx.$slots, "default")], 14, _hoisted_5$4), [[_directive_loading, $props.loading]]), $props.isFooter ? (openBlock(), createElementBlock("div", _hoisted_6$2, [createVNode(_component_gj_button, {
        type: "minor",
        onClick: $setup.handleCancel
      }, {
        "default": withCtx(function() {
          return [createTextVNode(toDisplayString($props.cancelButtonText || $setup.t("gj.search.cancelButtonText")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), createVNode(_component_gj_button, {
        type: "primary",
        loading: $props.confirmLoading,
        onClick: $setup.handleConfirm
      }, {
        "default": withCtx(function() {
          return [createTextVNode(toDisplayString($props.confirmButtonText || $setup.t("gj.search.confirmButtonText")), 1)];
        }),
        _: 1
      }, 8, ["loading", "onClick"])])) : createCommentVNode("", true)], 4)], 4)) : createCommentVNode("", true)];
    }),
    _: 3
  })], 8, ["to", "disabled"]);
}
_sfc_main$G.render = _sfc_render$F;
var _excluded$1 = ["close", "confirm"];
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var convertJsonKey = function convertJsonKey2(obj) {
  var result = {};
  for (var key in obj) {
    var keyVal = obj[key];
    key = "on".concat(key.replace(key[0], key[0].toUpperCase()));
    result[key] = keyVal;
  }
  return result;
};
_sfc_main$G.install = function(app) {
  app.component(_sfc_main$G.name, _sfc_main$G);
  app.config.globalProperties.$modal = function(_ref) {
    var options = _ref.options, component = _ref.component, childProps = _ref.props, _ref$on = _ref.on, on2 = _ref$on === void 0 ? {} : _ref$on;
    var container = document.createElement("div");
    var close = on2.close, confirm = on2.confirm, child = _objectWithoutProperties$1(on2, _excluded$1);
    var onChild = convertJsonKey(child);
    var componentVnode = h(component, _objectSpread$3(_objectSpread$3({}, childProps), onChild));
    var vnode = h(GjPopUp, {
      onConfirm: function onConfirm(value) {
        if (confirm) {
          confirm(value, _closeModal);
        }
      },
      "onUpdate:modelValue": function onUpdateModelValue(value) {
        if (!value)
          _closeModal();
      },
      onClose: function onClose(value) {
        if (close) {
          close(value);
        }
      }
    }, _objectSpread$3({
      "default": function _default44() {
        return componentVnode;
      }
    }, isVNode(options.titleExtra) && {
      "title-extra": function titleExtra() {
        return options.titleExtra;
      }
    }));
    vnode.appContext = app._context;
    render(vnode, container);
    var instance = vnode.component;
    document.body.appendChild(container);
    var props = instance.props;
    Object.assign(props, options, {
      modelValue: true
    });
    var _closeModal = function _closeModal2() {
      props.modelValue = false;
      container.parentNode.removeChild(container);
    };
  };
};
var GjPopUp = _sfc_main$G;
var _sfc_main$F = {
  name: "GjPopover",
  inheritAttrs: false,
  props: {
    effect: {
      type: String,
      "default": "light"
    },
    visible: {
      type: Boolean,
      "default": false
    },
    trigger: {
      type: String,
      "default": "click",
      validator: function validator9(v) {
        return ["click", "focus", "hover", "manual"].includes(v);
      }
    },
    popperClass: {
      type: String,
      Array
    }
  },
  emits: ["close"],
  setup: function setup19(props, _ref) {
    var emit = _ref.emit;
    var className = computed(function() {
      var str;
      if (props.effect === "dark") {
        str = "gj-popover_popper is-gj-dark";
      } else {
        str = "gj-popover_popper";
      }
      if (props.popperClass) {
        str = "".concat(str, " ").concat(props.popperClass);
      }
      return str;
    });
    var proxyValue = ref(false);
    onMounted(function() {
      if (props.visible !== null && props.visible !== void 0) {
        proxyValue.value = props.visible;
      }
    });
    watch(function() {
      return props.visible;
    }, function(newVal, oldVal) {
      if (newVal !== null && newVal !== void 0 && newVal !== oldVal) {
        proxyValue.value = newVal;
      }
    });
    var close = function close2() {
      proxyValue.value = false;
      emit("close");
    };
    return {
      className,
      proxyValue,
      close,
      customMask: computed(function() {
        return props.trigger === "manual";
      })
    };
  }
};
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_popover = resolveComponent("el-popover");
  return openBlock(), createBlock(_component_el_popover, mergeProps({
    visible: $setup.proxyValue,
    "onUpdate:visible": _cache[0] || (_cache[0] = function($event) {
      return $setup.proxyValue = $event;
    })
  }, _ctx.$attrs, {
    trigger: $props.trigger,
    "popper-class": $setup.className
  }), createSlots({
    _: 2
  }, [_ctx.$slots["default"] ? {
    name: "default",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    })
  } : void 0, _ctx.$slots.reference ? {
    name: "reference",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "reference")];
    })
  } : void 0]), 1040, ["visible", "trigger", "popper-class"]);
}
_sfc_main$F.render = _sfc_render$E;
var _sfc_main$E = {
  components: {
    gjPopover: _sfc_main$F,
    gjImage: _sfc_main$M
  },
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: String,
      "default": "xs"
    },
    replace: {
      type: String
    },
    handleUrl: {
      type: Function
    }
  },
  setup: function setup20(props) {
    var bigUrl = computed(function() {
      if (!props.src)
        return "";
      if (!props.handleUrl) {
        return props.replace ? props.src.replace(props.replace, "") : props.src;
      } else {
        return props.handleUrl(props.src);
      }
    });
    return {
      bigUrl
    };
  }
};
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_image = resolveComponent("gj-image");
  var _component_gj_popover = resolveComponent("gj-popover");
  return openBlock(), createBlock(_component_gj_popover, {
    placement: "right-start",
    trigger: "hover",
    width: "200",
    "show-after": 500,
    "hide-after": 100
  }, {
    reference: withCtx(function() {
      return [createVNode(_component_gj_image, mergeProps({
        src: $props.src,
        size: $props.size
      }, _ctx.$attrs), null, 16, ["src", "size"])];
    }),
    "default": withCtx(function() {
      return [createVNode(_component_gj_image, {
        src: $setup.bigUrl,
        size: "xl"
      }, null, 8, ["src"])];
    }),
    _: 1
  });
}
_sfc_main$E.render = _sfc_render$D;
var _sfc_main$D = {
  name: "GjPopoverSuper",
  components: {
    tableImage: _sfc_main$E
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: function validator10(t) {
        return ["table-image"].includes(t);
      }
    }
  }
};
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.mode), normalizeProps(guardReactiveProps(_ctx.$attrs)), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$D.render = _sfc_render$C;
var GjPopover = withInstall(_sfc_main$F, {
  popoverSuper: _sfc_main$D
});
var GjPopoverSuper = withNoopInstall(_sfc_main$D);
var sizes = ["medium", "small", "mini"];
var _sfc_main$C = {
  name: "GjProgress",
  props: {
    size: {
      type: String,
      "default": "medium",
      validator: function validator11(t) {
        return sizes.includes(t);
      }
    },
    width: Number
  },
  setup: function setup21(props) {
    var strokeWidth = computed(function() {
      if (props.width) {
        return props.width;
      } else {
        return [12, 8, 4][sizes.findIndex(function(v) {
          return v === props.size;
        })];
      }
    });
    return {
      strokeWidth
    };
  }
};
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_progress = resolveComponent("el-progress");
  return openBlock(), createBlock(_component_el_progress, mergeProps(_ctx.$attrs, {
    "class": "gj-progress",
    "stroke-width": $setup.strokeWidth
  }), null, 16, ["stroke-width"]);
}
_sfc_main$C.render = _sfc_render$B;
var GjProgress = withInstall(_sfc_main$C);
var _sfc_main$B = {
  name: "GjRadio"
};
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio = resolveComponent("el-radio");
  return openBlock(), createBlock(_component_el_radio, mergeProps(_ctx.$attrs, {
    "class": ["gj-radio"]
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$B.render = _sfc_render$A;
var _sfc_main$A = {
  name: "GjRadioGroup"
};
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio_group = resolveComponent("el-radio-group");
  return openBlock(), createBlock(_component_el_radio_group, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$A.render = _sfc_render$z;
var _sfc_main$z = {
  name: "GjRadioButton"
};
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio_button = resolveComponent("el-radio-button");
  return openBlock(), createBlock(_component_el_radio_button, mergeProps({
    "class": ["gj-radio"]
  }, _ctx.$attrs), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$z.render = _sfc_render$y;
var GjRadio = withInstall(_sfc_main$B, {
  radioGroup: _sfc_main$A,
  radioButton: _sfc_main$z
});
var GjRadioGroup = withNoopInstall(_sfc_main$A);
var GjRadioButton = withNoopInstall(_sfc_main$z);
var _sfc_main$y = {
  name: "GjRate",
  props: {
    colors: {
      type: Array,
      "default": function _default9() {
        return ["#FAD20C", "#FAD20C", "#FAD20C"];
      }
    },
    voidColor: {
      type: String,
      "default": "#D8DADD"
    }
  }
};
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_rate = resolveComponent("el-rate");
  return openBlock(), createBlock(_component_el_rate, mergeProps(_ctx.$attrs, {
    "class": ["gj-rate"],
    "void-color": $props.voidColor,
    colors: $props.colors
  }), null, 16, ["void-color", "colors"]);
}
_sfc_main$y.render = _sfc_render$x;
var GjRate = withInstall(_sfc_main$y);
var _sfc_main$x = {
  name: "GjScrollbar",
  props: {
    type: {
      type: String,
      "default": "normal",
      validator: function validator12(t) {
        return ["normal", "mini"].includes(t);
      }
    }
  },
  setup: function setup22(props) {
    return {
      className: "gj-scroll".concat(props.type === "normal" ? "" : "-mini")
    };
  }
};
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_scrollbar = resolveComponent("el-scrollbar");
  return openBlock(), createBlock(_component_el_scrollbar, mergeProps(_ctx.$attrs, {
    "class": [$setup.className]
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16, ["class"]);
}
_sfc_main$x.render = _sfc_render$w;
var GjScrollbar = withInstall(_sfc_main$x);
var _sfc_main$w = {
  name: "GjSelectMore",
  components: {
    gjSelect: _sfc_main$Z,
    gjOption: _sfc_main$Y,
    gjInput: _sfc_main$V
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
      "default": function _default10() {
        return [];
      }
    },
    list: {
      type: Array,
      required: true,
      "default": function _default11() {
        return [];
      }
    },
    labelKey: {
      type: String,
      "default": "text"
    },
    valueKey: {
      type: String,
      "default": "id"
    },
    filterable: {
      type: Boolean,
      "default": true
    },
    hasMax: {
      type: Boolean,
      "default": true
    },
    collapseTags: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["change-object", "change"],
  setup: function setup23(props, _ref) {
    var emit = _ref.emit;
    var computedActive = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(v) {
        emit("update:modelValue", v);
      }
    });
    var _useLocale = useLocale(), t = _useLocale.t;
    var checked = ref(false);
    var selectAll = function selectAll2() {
      if (checked.value) {
        var tpl = [];
        checkOptions.value.forEach(function(v) {
          if (!computedActive.value.includes(v[props.valueKey]) && !v.disabled) {
            tpl.push(v[props.valueKey]);
          }
        });
        computedActive.value = [].concat(_toConsumableArray(computedActive.value), tpl);
      } else {
        var _tpl = _toConsumableArray(computedActive.value);
        checkOptions.value.forEach(function(v) {
          var index2 = _tpl.findIndex(function(item) {
            return item === v[props.valueKey];
          });
          if (index2 >= 0) {
            _tpl.splice(index2, 1);
          }
        });
        computedActive.value = _tpl;
      }
    };
    watch(computedActive, function(v, o) {
      setCheckValue();
      if (v && o) {
        var emptyNew = v && v.length === 0;
        var emptyOld = o && o.length === 0;
        if (emptyNew && !emptyOld)
          ;
        else if (!emptyNew && emptyOld)
          ;
        else if (v.length === o.length) {
          var diffArray = lodash.exports.difference(v, o);
          if (diffArray.length === 0)
            return;
        }
      }
      handleChange();
      handleEmitObject();
    });
    var filterText = ref("");
    var checkOptions = ref([]);
    var setCheckValue = function setCheckValue2() {
      if (checkOptions.value.length === 0)
        return;
      checked.value = checkOptions.value.filter(function(v) {
        return !v.disabled;
      }).every(function(v) {
        return computedActive.value.includes(v[props.valueKey]);
      });
    };
    var handleChange = function handleChange2() {
      return emit("change", toRaw(computedActive.value));
    };
    var handleEmitObject = function handleEmitObject2() {
      emit("change-object", toRaw(computedActive.value).map(function(v) {
        return toRaw(props.list).find(function(n) {
          return n[props.valueKey] === v;
        });
      }));
    };
    onMounted(function() {
      checkOptions.value = filterOption(filterText.value, props.list);
      computedActive.value = props.modelValue || [];
    });
    watch(function() {
      return props.list;
    }, function(val1) {
      checkOptions.value = filterOption(filterText.value, val1);
    });
    watch(function() {
      return filterText.value;
    }, function(_2) {
      checkOptions.value = filterOption(filterText.value, props.list);
    });
    function filterOption(text, list) {
      return text === "" ? list : list.filter(function(v) {
        return v[props.labelKey].toLowerCase().includes(text.toLowerCase());
      });
    }
    return {
      t,
      checked,
      filterText,
      checkOptions,
      computedActive,
      selectAll,
      emptyImg
    };
  }
};
var _hoisted_1$j = {
  "class": "select-more-column"
};
var _hoisted_2$e = {
  key: 0,
  "class": "select-all"
};
var _hoisted_3$c = /* @__PURE__ */ createElementVNode("span", {
  "class": "checkbox"
}, null, -1);
var _hoisted_4$6 = {
  "class": "label-name-box"
};
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$computedActiv, _$setup$computedActiv2;
  var _component_gj_input = resolveComponent("gj-input");
  var _component_el_checkbox = resolveComponent("el-checkbox");
  var _component_gj_option = resolveComponent("gj-option");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_el_option = resolveComponent("el-option");
  var _component_gj_select = resolveComponent("gj-select");
  return openBlock(), createBlock(_component_gj_select, mergeProps({
    modelValue: $setup.computedActive,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function($event) {
      return $setup.computedActive = $event;
    }),
    "value-key": "value",
    "popper-class": "gj-custom-select--popper",
    multiple: "",
    "collapse-tags": $props.collapseTags,
    "class": [((_$setup$computedActiv = $setup.computedActive) === null || _$setup$computedActiv === void 0 ? void 0 : _$setup$computedActiv.length) === 1 && $props.collapseTags && "multiple-tag-width", ((_$setup$computedActiv2 = $setup.computedActive) === null || _$setup$computedActiv2 === void 0 ? void 0 : _$setup$computedActiv2.length) > 1 && $props.collapseTags && "multiple-tag-width-more", "gj-select--more"]
  }, _ctx.$attrs, {
    clearable: ""
  }), {
    "default": withCtx(function() {
      return [createVNode(_component_el_option, {
        value: "-1",
        "class": normalizeClass(["gj-select-more-options", $props.hasMax && "has-max"]),
        disabled: ""
      }, {
        "default": withCtx(function() {
          return [$props.filterable && $props.list.length > 0 ? (openBlock(), createElementBlock("div", {
            key: 0,
            "class": "gj-select-more-input",
            onClick: _cache[1] || (_cache[1] = withModifiers(function() {
            }, ["stop"]))
          }, [createVNode(_component_gj_input, {
            modelValue: $setup.filterText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
              return $setup.filterText = $event;
            }),
            placeholder: $setup.t("gj.search.search")
          }, null, 8, ["modelValue", "placeholder"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_1$j, [$setup.checkOptions.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_2$e, [createVNode(_component_el_checkbox, {
            modelValue: $setup.checked,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function($event) {
              return $setup.checked = $event;
            }),
            onChange: $setup.selectAll
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.select.all")), 1)];
            }),
            _: 1
          }, 8, ["modelValue", "onChange"])])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList($setup.checkOptions, function(item, index2) {
            return openBlock(), createBlock(_component_gj_option, {
              key: "".concat(item[$props.valueKey]).concat(index2),
              label: item[$props.labelKey],
              value: item[$props.valueKey],
              disabled: item.disabled
            }, {
              "default": withCtx(function() {
                return [renderSlot(_ctx.$slots, "item", {
                  item
                }, function() {
                  return [_hoisted_3$c, createElementVNode("span", _hoisted_4$6, toDisplayString(item[$props.labelKey]), 1)];
                })];
              }),
              _: 2
            }, 1032, ["label", "value", "disabled"]);
          }), 128)), $setup.checkOptions.length === 0 ? (openBlock(), createBlock(_component_el_empty, {
            key: 1,
            "class": "gj-select__empty",
            image: $setup.emptyImg,
            description: $setup.t("gj.emptyText")
          }, null, 8, ["image", "description"])) : createCommentVNode("", true)])];
        }),
        _: 3
      }, 8, ["class"])];
    }),
    _: 3
  }, 16, ["modelValue", "collapse-tags", "class"]);
}
_sfc_main$w.render = _sfc_render$v;
var _sfc_main$v = {
  name: "GjSelectTree",
  components: {
    gjSelect: _sfc_main$Z,
    gjInput: _sfc_main$V
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
      "default": function _default12() {
        return [];
      }
    },
    tree: {
      type: Array,
      required: true,
      "default": function _default13() {
        return [];
      }
    },
    nodeKey: {
      type: String,
      "default": "id"
    },
    defaultProps: {
      type: Object,
      "default": function _default14() {
        return {
          children: "children",
          label: "label"
        };
      }
    },
    filterable: {
      type: Boolean,
      "default": true
    },
    hasMax: {
      type: Boolean,
      "default": true
    },
    fixedHeight: {
      type: Boolean,
      "default": false
    },
    collapseTags: {
      type: Boolean,
      "default": false
    },
    defaultExpandAll: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["update:modelValue", "change-object"],
  setup: function setup24(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var active = ref([]);
    var optionValue = ref([]);
    var treeRef = ref(null);
    var openedTree = function openedTree2(tree) {
      if (tree.length === 0)
        return [];
      return _.cloneDeep(tree).reduce(function(acc, item) {
        var _props$defaultProps, _props$defaultProps2;
        return item[(_props$defaultProps = props.defaultProps) === null || _props$defaultProps === void 0 ? void 0 : _props$defaultProps.children] ? acc.concat(item, openedTree2(item[(_props$defaultProps2 = props.defaultProps) === null || _props$defaultProps2 === void 0 ? void 0 : _props$defaultProps2.children])) : acc.concat(item);
      }, []).map(function(v) {
        var _props$defaultProps3;
        if (v[(_props$defaultProps3 = props.defaultProps) === null || _props$defaultProps3 === void 0 ? void 0 : _props$defaultProps3.children]) {
          var _props$defaultProps4;
          delete v[(_props$defaultProps4 = props.defaultProps) === null || _props$defaultProps4 === void 0 ? void 0 : _props$defaultProps4.children];
        }
        return v;
      });
    };
    var openedData = ref([]);
    onMounted(function() {
      openedData.value = openedTree(props.tree);
      optionValue.value = openedData.value.filter(function(v) {
        return props.modelValue.includes(v[props.nodeKey]);
      });
    });
    watch(function() {
      return props.modelValue;
    }, function(newVal, oldVal) {
      optionValue.value = openedData.value.filter(function(v) {
        return newVal.includes(v[props.nodeKey]);
      });
      treeRef.value.setCheckedNodes(optionValue.value);
    });
    watch(function() {
      return props.tree;
    }, function(newVal, oldVal) {
      if (newVal.length > 0) {
        openedData.value = openedTree(props.tree);
        optionValue.value = openedData.value.filter(function(v) {
          return props.modelValue.includes(v[props.nodeKey]);
        });
      }
    });
    watch(optionValue, function() {
      active.value = optionValue.value.map(function(v) {
        return v[props.defaultProps.label];
      });
    });
    var filterNode = function filterNode2() {
      var _data$props$defaultPr;
      var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      var data = arguments.length > 1 ? arguments[1] : void 0;
      if (!value)
        return true;
      return ((_data$props$defaultPr = data[props.defaultProps.label]) === null || _data$props$defaultPr === void 0 ? void 0 : _data$props$defaultPr.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1;
    };
    var filterText = ref("");
    watch(filterText, function() {
      treeRef.value.filter(filterText.value);
    });
    var handleTreeCheckChange = function handleTreeCheckChange2() {
      var checkers = treeRef.value.getCheckedNodes(true, true);
      emit("update:modelValue", checkers.map(function(v) {
        return v[props.nodeKey];
      }));
      emit("change-object", checkers.map(function(v) {
        return toRaw(v);
      }));
    };
    var handleSelectChange = function handleSelectChange2(val) {
      var arr = optionValue.value.filter(function(v) {
        return val.includes(v[props.defaultProps.label]);
      });
      treeRef.value.setCheckedNodes(arr);
      emit("update:modelValue", arr.map(function(v) {
        return v[props.nodeKey];
      }));
    };
    return {
      t,
      filterText,
      treeRef,
      active,
      optionValue,
      filterNode,
      handleTreeCheckChange,
      handleSelectChange
    };
  }
};
var _hoisted_1$i = {
  "class": "el-tree-node__label"
};
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$active, _$setup$active2;
  var _component_gj_input = resolveComponent("gj-input");
  var _component_el_tree = resolveComponent("el-tree");
  var _component_el_option = resolveComponent("el-option");
  var _component_gj_select = resolveComponent("gj-select");
  return openBlock(), createBlock(_component_gj_select, mergeProps({
    modelValue: $setup.active,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function($event) {
      return $setup.active = $event;
    }),
    "value-key": "value",
    "popper-class": "gj-custom-select--popper",
    multiple: "",
    "collapse-tags": $props.collapseTags,
    "class": [((_$setup$active = $setup.active) === null || _$setup$active === void 0 ? void 0 : _$setup$active.length) === 1 && $props.collapseTags && "multiple-tag-width", ((_$setup$active2 = $setup.active) === null || _$setup$active2 === void 0 ? void 0 : _$setup$active2.length) > 1 && $props.collapseTags && "multiple-tag-width-more", "gj-select--more"],
    clearable: ""
  }, _ctx.$attrs, {
    onChange: $setup.handleSelectChange
  }), {
    "default": withCtx(function() {
      return [createVNode(_component_el_option, {
        value: $setup.optionValue,
        "class": normalizeClass(["gj-select-more-options", $props.hasMax && "has-max", $props.fixedHeight && "fixed-height"]),
        disabled: ""
      }, {
        "default": withCtx(function() {
          return [$props.filterable ? (openBlock(), createElementBlock("div", {
            key: 0,
            "class": "gj-select-more-input",
            onClick: _cache[1] || (_cache[1] = withModifiers(function() {
            }, ["stop"]))
          }, [createVNode(_component_gj_input, {
            modelValue: $setup.filterText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
              return $setup.filterText = $event;
            }),
            placeholder: $setup.t("gj.search.search")
          }, null, 8, ["modelValue", "placeholder"])])) : createCommentVNode("", true), createVNode(_component_el_tree, {
            ref: "treeRef",
            "class": "gj-tree filter-tree",
            data: $props.tree,
            props: $props.defaultProps,
            "default-expand-all": $props.defaultExpandAll,
            "node-key": $props.nodeKey,
            "show-checkbox": "",
            "filter-node-method": $setup.filterNode,
            "default-checked-keys": $props.modelValue,
            onCheckChange: $setup.handleTreeCheckChange
          }, createSlots({
            _: 2
          }, [_ctx.$slots["default"] ? {
            name: "default",
            fn: withCtx(function(_ref2) {
              var node = _ref2.node, data = _ref2.data;
              return [renderSlot(_ctx.$slots, "default", {
                node,
                data
              }, function() {
                return [createElementVNode("span", _hoisted_1$i, toDisplayString(node.label), 1)];
              })];
            })
          } : void 0]), 1032, ["data", "props", "default-expand-all", "node-key", "filter-node-method", "default-checked-keys", "onCheckChange"])];
        }),
        _: 3
      }, 8, ["value", "class"])];
    }),
    _: 3
  }, 16, ["modelValue", "collapse-tags", "class", "onChange"]);
}
_sfc_main$v.render = _sfc_render$u;
var _sfc_main$u = {
  name: "GjSelectSingleTree",
  components: {
    gjSelect: _sfc_main$Z,
    gjInput: _sfc_main$V
  },
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    tree: {
      type: Array,
      required: true,
      "default": function _default15() {
        return [];
      }
    },
    nodeKey: {
      type: String,
      "default": "id"
    },
    defaultProps: {
      type: Object,
      "default": function _default16() {
        return {
          children: "children",
          label: "label",
          disabled: "disabled"
        };
      }
    },
    filterable: {
      type: Boolean,
      "default": false
    },
    hasMax: {
      type: Boolean,
      "default": true
    },
    onlyEnd: {
      type: Boolean,
      "default": false
    },
    fixedHeight: {
      type: Boolean,
      "default": false
    },
    defaultExpandAll: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["update:modelValue", "change-object"],
  setup: function setup25(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var openedTree = function openedTree2() {
      var tree = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return _.cloneDeep(tree).reduce(function(acc, item) {
        var _props$defaultProps, _props$defaultProps2;
        return item[(_props$defaultProps = props.defaultProps) === null || _props$defaultProps === void 0 ? void 0 : _props$defaultProps.children] ? acc.concat(item, openedTree2(item[(_props$defaultProps2 = props.defaultProps) === null || _props$defaultProps2 === void 0 ? void 0 : _props$defaultProps2.children])) : acc.concat(item);
      }, []).map(function(v) {
        var _props$defaultProps3;
        if (v[(_props$defaultProps3 = props.defaultProps) === null || _props$defaultProps3 === void 0 ? void 0 : _props$defaultProps3.children]) {
          var _props$defaultProps4;
          delete v[(_props$defaultProps4 = props.defaultProps) === null || _props$defaultProps4 === void 0 ? void 0 : _props$defaultProps4.children];
        }
        return v;
      });
    };
    var openedData = ref([]);
    var active = ref("");
    watch([function() {
      return props.modelValue;
    }, function() {
      return props.tree;
    }], function(_ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 2), newVal1 = _ref4[0], newVal2 = _ref4[1];
      var _ref5 = _slicedToArray(_ref3, 2), oldVal1 = _ref5[0];
      _ref5[1];
      if (newVal1 && newVal2.length > 0) {
        openedData.value = openedTree(props.tree);
        active.value = openedData.value.filter(function(v) {
          return v[props.nodeKey] === newVal1;
        })[0][props.defaultProps.label];
        nextTick(function() {
          treeRef.value.setCurrentKey(props.modelValue);
        });
      } else if (newVal1 !== oldVal1 && newVal1 === "") {
        active.value = "";
        nextTick(function() {
          treeRef.value.setCurrentKey("");
        });
      }
    }, {
      immediate: true
    });
    var filterNode = function filterNode2() {
      var _data$props$defaultPr;
      var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      var data = arguments.length > 1 ? arguments[1] : void 0;
      if (!value)
        return true;
      return ((_data$props$defaultPr = data[props.defaultProps.label]) === null || _data$props$defaultPr === void 0 ? void 0 : _data$props$defaultPr.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1;
    };
    var treeRef = ref(null);
    var selectRef = ref(null);
    var filterText = ref("");
    watch(filterText, function() {
      treeRef.value.filter(filterText.value);
    });
    var handleNodeClick = function handleNodeClick2(val) {
      var _props$defaultProps5, _props$defaultProps6;
      if (val[props.defaultProps.disabled]) {
        return;
      }
      if (props.onlyEnd && val[(_props$defaultProps5 = props.defaultProps) === null || _props$defaultProps5 === void 0 ? void 0 : _props$defaultProps5.children] && val[(_props$defaultProps6 = props.defaultProps) === null || _props$defaultProps6 === void 0 ? void 0 : _props$defaultProps6.children].length > 0) {
        return;
      }
      emit("update:modelValue", val[props.nodeKey]);
      emit("change-object", toRaw(val));
      selectRef.value.root.handleClose();
    };
    var handleClear = function handleClear2() {
      emit("change-object", "");
      emit("update:modelValue", "");
    };
    return {
      t,
      filterText,
      treeRef,
      active,
      filterNode,
      handleNodeClick,
      handleClear,
      selectRef
    };
  }
};
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_input = resolveComponent("gj-input");
  var _component_el_tree = resolveComponent("el-tree");
  var _component_el_option = resolveComponent("el-option");
  var _component_gj_select = resolveComponent("gj-select");
  return openBlock(), createBlock(_component_gj_select, {
    ref: "selectRef",
    modelValue: $setup.active,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function($event) {
      return $setup.active = $event;
    }),
    "value-key": "value",
    "popper-class": "gj-custom-select--popper",
    clearable: "",
    onClear: $setup.handleClear
  }, {
    "default": withCtx(function() {
      return [createVNode(_component_el_option, {
        value: "-1",
        "class": normalizeClass(["gj-select-more-options", $props.hasMax && "has-max", $props.fixedHeight && "fixed-height"]),
        disabled: ""
      }, {
        "default": withCtx(function() {
          return [$props.filterable ? (openBlock(), createElementBlock("div", {
            key: 0,
            "class": "gj-select-more-input",
            onClick: _cache[1] || (_cache[1] = withModifiers(function() {
            }, ["stop"]))
          }, [createVNode(_component_gj_input, {
            modelValue: $setup.filterText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
              return $setup.filterText = $event;
            }),
            placeholder: $setup.t("gj.search.search")
          }, null, 8, ["modelValue", "placeholder"])])) : createCommentVNode("", true), createVNode(_component_el_tree, {
            ref: "treeRef",
            "class": "gj-tree filter-tree",
            data: $props.tree,
            "highlight-current": "",
            props: $props.defaultProps,
            "default-expand-all": $props.defaultExpandAll,
            "node-key": $props.nodeKey,
            "filter-node-method": $setup.filterNode,
            onNodeClick: $setup.handleNodeClick
          }, {
            "default": withCtx(function(_ref6) {
              var node = _ref6.node, data = _ref6.data;
              return [renderSlot(_ctx.$slots, "default", {
                node,
                data
              }, function() {
                return [createElementVNode("span", {
                  "class": normalizeClass(["el-tree-node__label", [node.disabled && "is-disabled"]])
                }, toDisplayString(node.label), 3)];
              })];
            }),
            _: 3
          }, 8, ["data", "props", "default-expand-all", "node-key", "filter-node-method", "onNodeClick"])];
        }),
        _: 3
      }, 8, ["class"])];
    }),
    _: 3
  }, 8, ["modelValue", "onClear"]);
}
_sfc_main$u.render = _sfc_render$t;
var _sfc_main$t = {
  name: "GjSelectInputMore",
  components: {
    gjSelect: _sfc_main$Z,
    gjIconMore: _sfc_main$K
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
      "default": function _default17() {
        return [];
      }
    }
  },
  emits: ["update:modelValue"],
  setup: function setup26(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var active = ref([]);
    var handleSelectchange = function handleSelectchange2(val) {
      text.value = val.join("\n");
    };
    watch(active, function(_2) {
      emit("update:modelValue", active.value);
    });
    var text = ref("");
    var gjSelectInputRef = ref(null);
    var handleReset = function handleReset2() {
      text.value = "";
      active.value = [];
      gjSelectInputRef.value.root.blur();
    };
    var handleCancel = function handleCancel2() {
      gjSelectInputRef.value.root.blur();
    };
    var handleSubmit = function handleSubmit2() {
      var strArr = text.value.split("\n").filter(function(v) {
        return v !== "";
      });
      active.value = strArr;
      gjSelectInputRef.value.root.blur();
    };
    return {
      t,
      text,
      active,
      handleSelectchange,
      handleReset,
      handleCancel,
      handleSubmit,
      gjSelectInputRef
    };
  }
};
var _hoisted_1$h = {
  "class": "gj-select-input-bottom"
};
var _hoisted_2$d = {
  "class": "gj-select-input-bottom-right"
};
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = resolveComponent("el-input");
  var _component_gj_button = resolveComponent("gj-button");
  var _component_el_option = resolveComponent("el-option");
  var _component_gjIconMore = resolveComponent("gjIconMore");
  var _component_gj_select = resolveComponent("gj-select");
  return openBlock(), createBlock(_component_gj_select, mergeProps({
    ref: "gjSelectInputRef",
    modelValue: $setup.active,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function($event) {
      return $setup.active = $event;
    }),
    "value-key": "value",
    "popper-class": "gj-custom-select--popper",
    multiple: ""
  }, _ctx.$attrs, {
    "class": "gj-select-input-more",
    onChange: $setup.handleSelectchange
  }), {
    append: withCtx(function() {
      return [createVNode(_component_gjIconMore, {
        "class": "gj-select-more-icon"
      })];
    }),
    "default": withCtx(function() {
      return [createVNode(_component_el_option, {
        value: "-1",
        "class": "gj-select-more-tree"
      }, {
        "default": withCtx(function() {
          return [createElementVNode("div", {
            "class": "gj-select-input",
            onClick: _cache[1] || (_cache[1] = withModifiers(function() {
            }, ["stop"]))
          }, [createVNode(_component_el_input, {
            modelValue: $setup.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
              return $setup.text = $event;
            }),
            placeholder: "\u4E00\u884C\u4E00\u9879\uFF0C\u6700\u591A\u8F93\u5165200\u884C",
            type: "textarea",
            rows: "8"
          }, null, 8, ["modelValue"]), createElementVNode("div", _hoisted_1$h, [createVNode(_component_gj_button, {
            size: "mini",
            onClick: $setup.handleReset
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.resetButtonText")), 1)];
            }),
            _: 1
          }, 8, ["onClick"]), createElementVNode("div", _hoisted_2$d, [createVNode(_component_gj_button, {
            type: "primary",
            plain: "",
            size: "mini",
            onClick: $setup.handleCancel
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.cancelButtonText")), 1)];
            }),
            _: 1
          }, 8, ["onClick"]), createVNode(_component_gj_button, {
            type: "primary",
            size: "mini",
            onClick: $setup.handleSubmit
          }, {
            "default": withCtx(function() {
              return [createTextVNode(toDisplayString($setup.t("gj.search.confirmButtonText")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])])])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 16, ["modelValue", "onChange"]);
}
_sfc_main$t.render = _sfc_render$s;
var _sfc_main$s = {
  name: "GjSelectSuper",
  components: {
    selectMore: _sfc_main$w,
    selectTree: _sfc_main$v,
    selectInput: _sfc_main$t,
    selectSingleTree: _sfc_main$u
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: function validator13(t) {
        return ["select-more", "select-tree", "select-single-tree"].includes(t);
      }
    }
  },
  setup: function setup27() {
    var selectSuperRef = ref(null);
    return {
      selectSuperRef
    };
  }
};
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.mode), mergeProps(_ctx.$attrs, {
    ref: "selectSuperRef"
  }), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$s.render = _sfc_render$r;
var GjSelect = withInstall(_sfc_main$Z, {
  option: _sfc_main$Y,
  selectMore: _sfc_main$w,
  selectTree: _sfc_main$v,
  selectSingleTree: _sfc_main$u,
  selectSuper: _sfc_main$s
});
var GjSelectOption = withNoopInstall(_sfc_main$Y);
var GjSelectSuper = withNoopInstall(_sfc_main$s);
var GjSelectMore = withNoopInstall(_sfc_main$w);
var GjSelectTree = withNoopInstall(_sfc_main$v);
var GjSelectSingleTree = withNoopInstall(_sfc_main$u);
var space_vue_vue_type_style_index_0_scoped_true_lang = "";
var __default__ = {
  name: "GjSpace",
  props: {
    grid: {
      type: Number,
      "default": 4
    },
    direction: {
      type: String,
      "default": "horizontal"
    }
  },
  setup: function setup28(props) {
    var width = ref(0);
    var height = ref(0);
    onMounted(function() {
      if (props.direction === "horizontal") {
        width.value = "100%";
        height.value = props.grid + "px";
      } else {
        height.value = "100%";
        width.value = props.grid + "px";
      }
    });
    return {
      width,
      height
    };
  }
};
var __injectCSSVars__2 = function __injectCSSVars__3() {
  useCssVars(function(_ctx) {
    return {
      "58dc47d1": _ctx.height,
      "f0580c48": _ctx.width
    };
  });
};
var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function(props, ctx) {
  __injectCSSVars__2();
  return __setup__(props, ctx);
} : __injectCSSVars__2;
var _sfc_main$r = __default__;
pushScopeId("data-v-b5b2b344");
var _hoisted_1$g = {
  "class": "gj-space"
};
popScopeId();
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$g);
}
_sfc_main$r.render = _sfc_render$q;
_sfc_main$r.__scopeId = "data-v-b5b2b344";
var GjSpace = withInstall(_sfc_main$r);
var _sfc_main$q = {
  name: "GjStep",
  props: {
    title: {
      type: String,
      required: true
    },
    desc: String,
    slotName: String,
    icon: String
  },
  emits: ["change"],
  setup: function setup29(props, _ref) {
    var emit = _ref.emit;
    var index2 = ref(-1);
    var parent = inject("GjSteps");
    var currentInstance = getCurrentInstance();
    onBeforeUnmount(function() {
      parent.steps.value = parent.steps.value.filter(function(instance) {
        return instance.uid !== currentInstance.uid;
      });
    });
    var setIndex = function setIndex2(val) {
      index2.value = val;
    };
    var stepItemState = reactive({
      uid: computed(function() {
        return currentInstance.uid;
      }),
      setIndex
    });
    parent.steps.value = [].concat(_toConsumableArray(parent.steps.value), [stepItemState]);
    var stepsCount = computed(function() {
      return parent.steps.value.length;
    });
    var isLast = computed(function() {
      var _parent$steps$value;
      return ((_parent$steps$value = parent.steps.value[stepsCount.value - 1]) === null || _parent$steps$value === void 0 ? void 0 : _parent$steps$value.uid) === currentInstance.uid;
    });
    var style = computed(function() {
      var style2 = null;
      if (parent.props.space) {
        style2 = {
          flexBasis: parent.props.space + "px"
        };
      } else {
        style2 = {
          flexBasis: 100 / (stepsCount.value - 1) + "%"
        };
        if (isLast.value && parent.props.direction === "horizontal") {
          style2.maxWidth = 100 / stepsCount.value + "%";
        }
      }
      return style2;
    });
    var isActive = computed(function() {
      return index2.value + 1 === parent.props.active;
    });
    var isFinish = computed(function() {
      return index2.value + 1 < parent.props.active;
    });
    var handleClick = function handleClick2() {
      emit("change", index2.value + 1);
    };
    return {
      index: index2,
      setIndex,
      parent,
      style,
      isLast,
      isActive,
      isFinish,
      isSpace: computed(function() {
        return parent.props.space;
      }),
      handleClick
    };
  }
};
var _hoisted_1$f = {
  "class": "gj-step-head"
};
var _hoisted_2$c = /* @__PURE__ */ createElementVNode("div", {
  "class": "gj-step-line"
}, null, -1);
var _hoisted_3$b = {
  key: 0,
  "class": "el-icon-circle-check gj-step-text-icon"
};
var _hoisted_4$5 = {
  key: 1,
  "class": "gj-step-text-inner"
};
var _hoisted_5$3 = {
  "class": "gj-step-main"
};
var _hoisted_6$1 = {
  "class": "gj-step-title"
};
var _hoisted_7$1 = {
  "class": "gj-step-content"
};
var _hoisted_8$1 = {
  key: 0
};
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["gj-step", $setup.isLast && !$setup.isSpace && "is-flex", $setup.isActive && "is-active", $setup.isFinish && "is-finish"]),
    style: normalizeStyle($setup.style)
  }, [createElementVNode("div", _hoisted_1$f, [_hoisted_2$c, createElementVNode("div", {
    "class": "gj-step-text",
    onClick: _cache[0] || (_cache[0] = function() {
      return $setup.handleClick && $setup.handleClick.apply($setup, arguments);
    })
  }, [$props.icon ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_ctx.$slots.icon ? renderSlot(_ctx.$slots, "icon", {
    key: 0
  }) : (openBlock(), createElementBlock("i", {
    key: 1,
    "class": normalizeClass($props.icon)
  }, null, 2))], 64)) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [$setup.isFinish ? (openBlock(), createElementBlock("i", _hoisted_3$b)) : (openBlock(), createElementBlock("div", _hoisted_4$5, toDisplayString($setup.index + 1), 1))], 64))])]), createElementVNode("div", _hoisted_5$3, [createElementVNode("div", _hoisted_6$1, toDisplayString($props.title), 1), createElementVNode("div", _hoisted_7$1, [$props.desc ? (openBlock(), createElementBlock("span", _hoisted_8$1, toDisplayString($props.desc), 1)) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [$props.slotName ? renderSlot(_ctx.$slots, $props.slotName, {
    key: 0
  }) : renderSlot(_ctx.$slots, "default", {
    key: 1
  })], 64))])])], 6);
}
_sfc_main$q.render = _sfc_render$p;
var _sfc_main$p = {
  name: "GjSteps",
  components: {
    step: _sfc_main$q
  },
  props: {
    active: {
      type: Number,
      "default": 0,
      required: true
    },
    direction: {
      type: String,
      "default": "horizontal",
      validator: function validator14(t) {
        return ["horizontal", "vertical"].includes(t);
      }
    },
    space: {
      type: [Number, String]
    },
    list: {
      type: Array,
      "default": function _default18() {
        return [];
      }
    }
  },
  emits: ["change"],
  setup: function setup30(props, _ref) {
    var emit = _ref.emit;
    var steps = ref([]);
    watch(steps, function() {
      steps.value.forEach(function(instance, index2) {
        instance.setIndex(index2);
      });
    });
    provide("GjSteps", {
      props,
      steps
    });
    watch(function() {
      return props.modelValue;
    }, function(newVal, oldVal) {
      emit("change", newVal, oldVal);
    });
    var handleChangeStep = function handleChangeStep2(index2) {
      emit("change", index2);
    };
    return {
      steps,
      handleChangeStep
    };
  }
};
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_step = resolveComponent("step");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["gj-steps", "gj-steps-".concat($props.direction)])
  }, [$props.list.length > 0 ? (openBlock(true), createElementBlock(Fragment, {
    key: 0
  }, renderList($props.list, function(item, index2) {
    return openBlock(), createBlock(_component_step, {
      key: index2,
      title: item.title,
      desc: item.desc,
      slotname: item.slot,
      onChange: $setup.handleChangeStep
    }, null, 8, ["title", "desc", "slotname", "onChange"]);
  }), 128)) : renderSlot(_ctx.$slots, "default", {
    key: 1
  })], 2);
}
_sfc_main$p.render = _sfc_render$o;
var GjSteps = withInstall(_sfc_main$p, {
  step: _sfc_main$q
});
var GjStep = withNoopInstall(_sfc_main$q);
var _sfc_main$o = {
  name: "GjSwitch",
  props: {
    size: {
      type: String,
      "default": "normal",
      validator: function validator15(v) {
        return ["normal", "mini"].includes(v);
      }
    }
  }
};
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_switch = resolveComponent("el-switch");
  return openBlock(), createBlock(_component_el_switch, mergeProps(_ctx.$attrs, {
    "class": ["gj-switch-".concat($props.size)]
  }), null, 16, ["class"]);
}
_sfc_main$o.render = _sfc_render$n;
var GjSwitch = withInstall(_sfc_main$o);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var runtime = { exports: {} };
(function(module) {
  var runtime2 = function(exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
      generator._invoke = makeInvokeMethod(innerFn, self2, context);
      return generator;
    }
    exports.wrap = wrap;
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        define(prototype, method, function(arg) {
          return this._invoke(method, arg);
        });
      });
    }
    exports.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
    exports.awrap = function(arg) {
      return { __await: arg };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function(value2) {
              invoke("next", value2, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    });
    exports.AsyncIterator = AsyncIterator;
    exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0)
        PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self2, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self2, context);
          if (record.type === "normal") {
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        context.delegate = null;
        if (context.method === "throw") {
          if (delegate.iterator["return"]) {
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        context[delegate.resultName] = info.value;
        context.next = delegate.nextLoc;
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        return info;
      }
      context.delegate = null;
      return ContinueSentinel;
    }
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    define(Gp, iteratorSymbol, function() {
      return this;
    });
    define(Gp, "toString", function() {
      return "[object Generator]";
    });
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports.keys = function(object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();
      return function next() {
        while (keys.length) {
          var key2 = keys.pop();
          if (key2 in object) {
            next.value = key2;
            next.done = false;
            return next;
          }
        }
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1, next = function next2() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next2.value = iterable[i];
                next2.done = false;
                return next2;
              }
            }
            next2.value = undefined$1;
            next2.done = true;
            return next2;
          };
          return next.next = next;
        }
      }
      return { next: doneResult };
    }
    exports.values = values;
    function doneResult() {
      return { value: undefined$1, done: true };
    }
    Context.prototype = {
      constructor: Context,
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        };
        if (this.method === "next") {
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };
    return exports;
  }(module.exports);
  try {
    regeneratorRuntime = runtime2;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime2;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime2);
    }
  }
})(runtime);
var regenerator = runtime.exports;
var _sfc_main$n = {
  name: "GjTabs",
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    list: {
      type: Array,
      "default": function _default19() {
        return [];
      },
      required: true
    },
    valueKey: {
      type: String,
      "default": "value"
    },
    borderButton: {
      type: Boolean,
      "default": true
    },
    next: {
      type: Function
    }
  },
  emits: ["update:modelValue"],
  setup: function setup31(props, _ref) {
    var emit = _ref.emit;
    var handleClick = /* @__PURE__ */ function() {
      var _ref2 = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee(val, index2) {
        var before;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!props.next) {
                  emit("update:modelValue", val[props.valueKey]);
                } else {
                  before = props.next();
                  if (before instanceof Promise) {
                    before.then(function(bool) {
                      if (bool === true) {
                        emit("update:modelValue", val[props.valueKey]);
                      }
                    });
                  } else if (before === true) {
                    emit("update:modelValue", val[props.valueKey]);
                  } else
                    ;
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function handleClick2(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var formatBadge = function formatBadge2(val) {
      return val > 99 ? "99+" : val;
    };
    return {
      handleClick,
      formatBadge
    };
  }
};
var _hoisted_1$e = ["onClick"];
var _hoisted_2$b = {
  "class": "gj-tabs-content"
};
var _hoisted_3$a = {
  key: 0,
  "class": "gj-tabs-badge"
};
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    "class": normalizeClass(["gj-tabs", $props.borderButton && "is-border-button"])
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.list, function(item) {
    return openBlock(), createElementBlock("li", {
      key: item[$props.valueKey],
      "class": normalizeClass({
        "is-active": $props.modelValue === item[$props.valueKey]
      }),
      onClick: function onClick($event) {
        return $setup.handleClick(item);
      }
    }, [createElementVNode("div", _hoisted_2$b, [createElementVNode("span", null, toDisplayString(item.label), 1), item.badge ? (openBlock(), createElementBlock("span", _hoisted_3$a, toDisplayString($setup.formatBadge(item.badge)), 1)) : createCommentVNode("", true)])], 10, _hoisted_1$e);
  }), 128))], 2);
}
_sfc_main$n.render = _sfc_render$m;
var _sfc_main$m = {
  name: "GjTabsCap",
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    list: {
      type: Array,
      "default": function _default20() {
        return [];
      },
      required: true
    },
    valueKey: {
      type: String,
      "default": "value"
    },
    type: {
      type: String,
      "default": "normal",
      validator: function validator16(t) {
        return ["normal", "mini"].includes(t);
      }
    }
  },
  emits: ["update:modelValue"],
  setup: function setup32(props, _ref) {
    var emit = _ref.emit;
    var handleClick = function handleClick2(val) {
      emit("update:modelValue", val[props.valueKey]);
    };
    var formatBadge = function formatBadge2(val) {
      return val > 99 ? "99+" : val;
    };
    return {
      handleClick,
      formatBadge
    };
  }
};
var _hoisted_1$d = ["onClick"];
var _hoisted_2$a = {
  key: 0,
  "class": "gj-tabs-badge"
};
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    "class": normalizeClass(["gj-tabs-cap", "gj-tabs-cap-".concat($props.type)])
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.list, function(item) {
    return openBlock(), createElementBlock("li", {
      key: item[$props.valueKey],
      "class": normalizeClass({
        "is-active": $props.modelValue === item[$props.valueKey]
      }),
      onClick: function onClick($event) {
        return $setup.handleClick(item);
      }
    }, [createElementVNode("span", null, toDisplayString(item.label), 1), item.badge ? (openBlock(), createElementBlock("span", _hoisted_2$a, toDisplayString($setup.formatBadge(item.badge)), 1)) : createCommentVNode("", true)], 10, _hoisted_1$d);
  }), 128))], 2);
}
_sfc_main$m.render = _sfc_render$l;
var _sfc_main$l = {
  name: "GjTabsVertical",
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    list: {
      type: Array,
      "default": function _default21() {
        return [];
      },
      required: true
    },
    width: {
      type: Number,
      "default": 160
    },
    valueKey: {
      type: String,
      "default": "value"
    }
  },
  emits: ["update:modelValue"],
  setup: function setup33(props, _ref) {
    var emit = _ref.emit;
    var handleClick = function handleClick2(val) {
      emit("update:modelValue", val[props.valueKey]);
    };
    return {
      handleClick
    };
  }
};
var _hoisted_1$c = ["onClick"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    "class": "gj-tabs-vertical",
    style: normalizeStyle({
      width: $props.width + "px"
    })
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.list, function(item) {
    return openBlock(), createElementBlock("li", {
      key: item[$props.valueKey],
      "class": normalizeClass({
        "is-active": $props.modelValue === item[$props.valueKey]
      }),
      onClick: function onClick($event) {
        return $setup.handleClick(item);
      }
    }, [createElementVNode("span", null, toDisplayString(item.label), 1)], 10, _hoisted_1$c);
  }), 128))], 4);
}
_sfc_main$l.render = _sfc_render$k;
var _sfc_main$k = {
  name: "GjTabs",
  components: {
    normal: _sfc_main$n,
    cap: _sfc_main$m,
    vertical: _sfc_main$l
  },
  props: {
    mode: {
      type: String,
      "default": "normal",
      validator: function validator17(t) {
        return ["normal", "cap", "vertical"].includes(t);
      }
    }
  }
};
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.mode), normalizeProps(guardReactiveProps(_ctx.$attrs)), {
    "default": withCtx(function() {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}
_sfc_main$k.render = _sfc_render$j;
var tabsSuperKey = Symbol("tabsSuper");
var _sfc_main$j = {
  name: "GjTabsSuper",
  props: {
    modelValue: {
      type: String,
      required: true
    },
    borderButton: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["update:modelValue", "tab-click"],
  setup: function setup34(props, _ref) {
    _ref.slots;
    var emit = _ref.emit;
    var currentName = computed(function() {
      return props.modelValue;
    });
    var changeCurrentName = function changeCurrentName2(val) {
      emit("tab-click", val);
      emit("update:modelValue", val);
    };
    provide(tabsSuperKey, {
      currentName,
      changeCurrentName
    });
  }
};
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    "class": normalizeClass(["gj-tabs", $props.borderButton && "is-border-button"])
  }, [renderSlot(_ctx.$slots, "default")], 2);
}
_sfc_main$j.render = _sfc_render$i;
var _sfc_main$i = {
  name: "GjTabsItem",
  props: {
    label: {
      type: String
    },
    name: {
      type: String
    }
  },
  setup: function setup35(props) {
    var _inject = inject(tabsSuperKey), currentName = _inject.currentName, changeCurrentName = _inject.changeCurrentName;
    var handleClick = function handleClick2() {
      changeCurrentName(props.name);
    };
    return {
      currentName,
      handleClick
    };
  }
};
var _hoisted_1$b = {
  "class": "gj-tabs-content"
};
var _hoisted_2$9 = {
  key: 0
};
var _hoisted_3$9 = {
  key: 1
};
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    "class": normalizeClass({
      "is-active": $props.name === $setup.currentName
    }),
    onClick: _cache[0] || (_cache[0] = function() {
      return $setup.handleClick && $setup.handleClick.apply($setup, arguments);
    })
  }, [createElementVNode("div", _hoisted_1$b, [_ctx.$slots.label ? (openBlock(), createElementBlock("span", _hoisted_2$9, [renderSlot(_ctx.$slots, "label")])) : (openBlock(), createElementBlock("span", _hoisted_3$9, toDisplayString($props.label), 1))])], 2);
}
_sfc_main$i.render = _sfc_render$h;
var GjTab = withInstall(_sfc_main$k, {
  tabsItem: _sfc_main$i,
  tabsSuper: _sfc_main$j
});
var GjTabItem = withNoopInstall(_sfc_main$i);
var GjTabSuper = withNoopInstall(_sfc_main$j);
var _sfc_main$h = {
  name: "GjTag",
  props: {
    closable: {
      type: Boolean,
      "default": false
    },
    size: {
      type: String,
      "default": "normal",
      validator: function validator18(v) {
        return ["normal", "small"].includes(v);
      }
    },
    effect: {
      type: String,
      "default": "flat",
      validator: function validator19(v) {
        return ["flat", "line", "text"].includes(v);
      }
    },
    type: {
      type: String,
      "default": null,
      validator: function validator20(v) {
        return ["primary", "success", "danger", "warning", "info", "deep-info", "other"].includes(v);
      }
    }
  },
  emits: ["close"],
  setup: function setup36(props, _ref) {
    var emit = _ref.emit;
    var handldClose = function handldClose2() {
      return emit("close");
    };
    return {
      handldClose
    };
  }
};
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    "class": normalizeClass(["gj-tag", "gj-tag--".concat($props.effect), $props.type && "gj-tag--".concat($props.type), $props.size && "gj-tag--".concat($props.size)])
  }, [renderSlot(_ctx.$slots, "default"), $props.closable ? (openBlock(), createElementBlock("i", {
    key: 0,
    "class": "gj-tag__close el-icon-close",
    onClick: _cache[0] || (_cache[0] = withModifiers(function() {
      return $setup.handldClose && $setup.handldClose.apply($setup, arguments);
    }, ["stop"]))
  })) : createCommentVNode("", true)], 2);
}
_sfc_main$h.render = _sfc_render$g;
var GjTag = withInstall(_sfc_main$h);
var handleSuffix = function handleSuffix2(symbol) {
  return function(_ref) {
    var cellValue = _ref.cellValue;
    return "".concat(cellValue).concat(symbol);
  };
};
var handlePrefix = function handlePrefix2(symbol, amount) {
  return function(_ref2) {
    var cellValue = _ref2.cellValue, row = _ref2.row;
    if (symbol === "currencySymbol" || amount) {
      cellValue = handleAmount(cellValue);
    }
    return "".concat(row[symbol]).concat(cellValue);
  };
};
var handleDefaultShow = function handleDefaultShow2() {
  return function(_ref3) {
    var cellValue = _ref3.cellValue;
    var showValue = "-";
    if (isMeaningful(cellValue)) {
      showValue = cellValue;
    }
    return showValue;
  };
};
var handleEnum = function handleEnum2(options) {
  return function(_ref4) {
    var cellValue = _ref4.cellValue;
    if (!isMeaningful(cellValue))
      return "-";
    var element = options.find(function(v) {
      return v.id === cellValue;
    });
    return element ? element.text : cellValue;
  };
};
function handleAmount(val) {
  var num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  var result = toFixed(val, num);
  if (!result) {
    return val;
  }
  var thousandResult = amountThousandFormat(result);
  var arr = thousandResult.split(".");
  if (arr.length === 2) {
    return arr[1].length >= 2 ? thousandResult : thousandResult + "0";
  } else {
    return thousandResult + ".00";
  }
}
function amountThousandFormat(num) {
  return num.toString().replace(/\d+/, function(n) {
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ",";
    });
  });
}
var handleFormatter = function handleFormatter2(columns) {
  columns.forEach(function(v) {
    if (v.suffix) {
      v.formatter = handleSuffix(v.suffix);
    }
    if (v.prefix) {
      v.formatter = handlePrefix(v.prefix);
    }
    if (!v.suffix && !v.prefix && !v.slots && !v.formatter && !v.noFormat) {
      v.formatter = handleDefaultShow();
    }
    if (v.options) {
      v.options = typeof v.options === "function" ? v.options() : v.options;
      v.formatter = handleEnum(v.options);
    }
  });
  return columns;
};
var slotTypes = ["default", "content", "header", "title", "footer", "checkbox"];
var getSlots = function getSlots2(columns) {
  return recursiveColumns(columns).filter(function(v) {
    return v.slots;
  }).map(function(v) {
    return v.slots;
  }).map(function(v) {
    return Object.keys(v).map(function(i) {
      return slotTypes.includes(i) ? v[i] : null;
    }).filter(function(v2) {
      return v2;
    });
  }).flat();
};
var recursiveColumns = function recursiveColumns2(columns) {
  var result = [];
  columns.forEach(function(v) {
    result.push(v);
    if (v.children) {
      result = result.concat(recursiveColumns2(v.children));
    }
  });
  return result;
};
function useChildTable(childColumns) {
  var tableRef = ref(null);
  var columns = ref([]);
  watch(function() {
    return childColumns;
  }, function(newVal, oleVal) {
    columns.value = handleFormatter(_.cloneDeep(newVal));
  }, {
    deep: true,
    immediate: true
  });
  return {
    tableRef,
    slots: computed(function() {
      return getSlots(childColumns);
    }),
    columns
  };
}
var _sfc_main$g = {
  name: "GjVxeTable",
  components: {
    gjPagination: _sfc_main$H,
    tableImage: _sfc_main$E
  },
  props: {
    columns: {
      type: Array,
      "default": function _default22() {
        return [];
      },
      required: true
    },
    isSeq: {
      type: Boolean,
      "default": false
    },
    selection: {
      type: Boolean,
      "default": false
    },
    list: {
      type: Array,
      "default": function _default23() {
        return [];
      },
      required: true
    },
    loading: {
      type: Boolean,
      "default": false
    },
    showSummary: {
      type: Boolean,
      "default": false
    },
    summaryObject: {
      type: Object,
      "default": function _default24() {
      }
    },
    defaultSort: {
      type: Object,
      "default": null
    },
    pagerConfig: {
      type: Object,
      "default": null
    },
    childTableColumns: {
      type: Array,
      "default": function _default25() {
        return [];
      },
      required: false
    },
    childTableListKey: {
      type: String,
      "default": "children"
    },
    selectList: {
      type: Array,
      "default": function _default26() {
        return [];
      }
    },
    rowId: {
      type: String
    },
    checkboxConfig: {
      type: Object
    },
    tooltipConfig: {
      type: Object,
      "default": function _default27() {
        return {
          enterable: true,
          leaveDelay: 500
        };
      }
    }
  },
  emits: ["pagerChange", "checkbox-change", "sort-change", "update:selectList"],
  setup: function setup37(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t, lang = _useLocale.lang;
    var vxeGridRef = ref(null);
    var tableData = computed(function() {
      return props.list.map(function(v, i) {
        v.index = i + 1;
        return v;
      });
    });
    var realRowId = null;
    var alreadySlots = ["columnImage", "childTable"];
    var slotArr = computed(function() {
      return getSlots(props.columns).filter(function(v) {
        return !alreadySlots.includes(v);
      });
    });
    watch(function() {
      return props.summaryObject;
    }, function() {
      if (vxeGridRef.value) {
        vxeGridRef.value.updateFooter();
      }
    }, {
      deep: true
    });
    var handleFooterMethod = function handleFooterMethod2(_ref2) {
      _ref2.columns;
      _ref2.data;
      if (isMeaningful(props.summaryObject)) {
        var arr = tableColumn.value.map(function(v) {
          if (v.summary) {
            var summaryNum = props.summaryObject[v.id];
            if (isMeaningful(summaryNum)) {
              if (v.suffix) {
                summaryNum = "".concat(summaryNum).concat(v.suffix);
              }
            }
            v.summaryNum = summaryNum;
          }
          return v.summaryNum;
        });
        arr[0] = lang.value === "en" ? "Sum" : "\u5408\u8BA1";
        return [arr];
      } else {
        return [[]];
      }
    };
    var defaultCheckConfig = null;
    var handleColumns = function handleColumns2(columns) {
      columns = handleFormatter(columns);
      if (props.isSeq && !columns.some(function(v) {
        return v.type === "seq";
      }) && !columns.some(function(v) {
        return v.field === "index";
      })) {
        columns.unshift({
          id: "index",
          field: "index",
          title: "\u5E8F\u53F7",
          width: "55px",
          fixed: "left"
        });
      }
      if (props.selection && !columns.some(function(v) {
        return v.type === "checkbox";
      })) {
        columns.unshift({
          id: "checkbox",
          field: "checkbox",
          type: "checkbox",
          width: "45px",
          align: "center",
          fixed: "left"
        });
        realRowId = props.rowId || "id";
        defaultCheckConfig = {
          reserve: true
        };
      }
      return columns;
    };
    var tableColumn = ref([]);
    watch(function() {
      return props.columns;
    }, function(newVal, oleVal) {
      tableColumn.value = handleColumns(_.cloneDeep(newVal));
      if (vxeGridRef.value) {
        vxeGridRef.value.updateFooter();
      }
    }, {
      deep: true,
      immediate: true
    });
    var handleTablePagerChange = function handleTablePagerChange2(type, val) {
      return emit("pagerChange", type === "page" ? {
        page: val
      } : {
        pagesize: val,
        page: 1
      });
    };
    var handleCheckboxChange = function handleCheckboxChange2(val) {
      var allCheckRecords = [].concat(_toConsumableArray(val.records), _toConsumableArray(val.reserves));
      emit("update:selectList", allCheckRecords);
      emit("checkbox-change", val);
    };
    var handleSortChange = function handleSortChange2(val) {
      return emit("sort-change", val);
    };
    var _useChildTable = useChildTable(props.childTableColumns), vxeGridChildRef = _useChildTable.tableRef, childSlots = _useChildTable.slots, childColumns = _useChildTable.columns;
    watch(function() {
      return props.selectList;
    }, function(newVal) {
      if (newVal.length === 0) {
        vxeGridRef.value.clearCheckboxRow();
        vxeGridRef.value.clearCheckboxReserve();
      }
    }, {
      deep: true
    });
    return {
      t,
      vxeGridRef,
      tableData,
      tableColumn,
      slotArr,
      handleFooterMethod,
      handleTablePagerChange,
      handleCheckboxChange,
      handleSortChange,
      vxeGridChildRef,
      childSlots,
      childColumns,
      emptyImg,
      realRowId,
      tableCheckConfig: Object.assign(defaultCheckConfig || {}, props.checkboxConfig || {})
    };
  }
};
var _hoisted_1$a = {
  "class": "table-pager-box"
};
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_table_image = resolveComponent("table-image");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_vxe_grid = resolveComponent("vxe-grid");
  var _component_gj_pagination = resolveComponent("gj-pagination");
  var _directive_loading = resolveDirective("loading");
  return withDirectives((openBlock(), createBlock(_component_vxe_grid, mergeProps(_ctx.$attrs, {
    ref: "vxeGridRef",
    data: $setup.tableData,
    height: "auto",
    "auto-resize": "",
    "show-overflow": "",
    "row-config": {
      height: 52
    },
    round: "",
    "row-id": $setup.realRowId,
    "highlight-hover-row": "",
    "scroll-y": {
      gt: 100,
      enabled: true,
      mode: "wheel",
      onSize: 20
    },
    loading: false,
    "show-footer": $props.showSummary && $setup.tableData.length > 0,
    "footer-method": $setup.handleFooterMethod,
    columns: $setup.tableColumn,
    "sort-config": {
      trigger: "cell",
      defaultSort: $props.defaultSort,
      remote: true
    },
    "checkbox-config": $setup.tableCheckConfig,
    "tooltip-config": $props.tooltipConfig,
    "class": "gj-vxe-table is-scroll",
    onCheckboxChange: $setup.handleCheckboxChange,
    onCheckboxAll: $setup.handleCheckboxChange,
    onSortChange: $setup.handleSortChange
  }), createSlots({
    columnImage: withCtx(function(_ref3) {
      var row = _ref3.row, column = _ref3.column;
      return [createVNode(_component_table_image, {
        src: row[column.property]
      }, null, 8, ["src"])];
    }),
    empty: withCtx(function() {
      return [createVNode(_component_el_empty, {
        image: $setup.emptyImg,
        "image-size": 200,
        text: $setup.t("gj.emptyText")
      }, null, 8, ["image", "text"])];
    }),
    childTable: withCtx(function(_ref4) {
      var row = _ref4.row;
      return [createVNode(_component_vxe_grid, {
        ref: "vxeGridChildRef",
        "class": "gj-vxe-table gj-child-table",
        data: row[$props.childTableListKey],
        "max-height": "400px",
        loading: false,
        columns: $setup.childColumns,
        "scroll-y": {
          gt: 20,
          enabled: true,
          mode: "wheel",
          onSize: 20
        },
        "auto-resize": "",
        "show-overflow": "",
        "highlight-hover-row": ""
      }, createSlots({
        _: 2
      }, [renderList($setup.childSlots, function(item) {
        return {
          name: item,
          fn: withCtx(function(props) {
            return [renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(props)))];
          })
        };
      })]), 1032, ["data", "columns"])];
    }),
    _: 2
  }, [renderList($setup.slotArr, function(item) {
    return {
      name: item,
      fn: withCtx(function(props) {
        return [renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(props)))];
      })
    };
  }), $props.pagerConfig && $setup.tableData.length > 0 ? {
    name: "pager",
    fn: withCtx(function() {
      return [createElementVNode("div", _hoisted_1$a, [createVNode(_component_gj_pagination, {
        small: "",
        "current-page": $props.pagerConfig.page,
        "page-size": $props.pagerConfig.pagesize,
        total: $props.pagerConfig.total,
        background: $props.pagerConfig.background !== false,
        layout: $props.pagerConfig.layout || "total,sizes,prev,pager,next,jumper",
        onSizeChange: _cache[0] || (_cache[0] = function($event) {
          return $setup.handleTablePagerChange("pagesize", $event);
        }),
        onCurrentChange: _cache[1] || (_cache[1] = function($event) {
          return $setup.handleTablePagerChange("page", $event);
        })
      }, null, 8, ["current-page", "page-size", "total", "background", "layout"])])];
    })
  } : void 0]), 1040, ["data", "row-id", "show-footer", "footer-method", "columns", "sort-config", "checkbox-config", "tooltip-config", "onCheckboxChange", "onCheckboxAll", "onSortChange"])), [[_directive_loading, $props.loading]]);
}
_sfc_main$g.render = _sfc_render$f;
var _sfc_main$f = {
  name: "GjMiniList",
  props: {
    columns: {
      type: Array,
      "default": function _default28() {
        return [];
      },
      required: true
    },
    stripe: {
      type: Boolean,
      "default": true
    },
    hover: {
      type: Boolean,
      "default": false
    },
    list: {
      type: Array,
      "default": function _default29() {
        return [];
      },
      required: true
    },
    showSummary: {
      type: Boolean,
      "default": false
    },
    summaryObject: {
      type: Object,
      "default": function _default30() {
      }
    },
    height: {
      type: Number
    }
  },
  emits: ["change"],
  setup: function setup38(props, _ref) {
    _ref.emit;
    var summaryData = ref([]);
    var listColumns = computed(function() {
      return props.columns.map(function(v, i) {
        v.id = v.id || i + 1;
        v.width = v.width || "100px";
        v.align = v.align || "left";
        return v;
      });
    });
    var handleSummary = function handleSummary2() {
      if (props.showSummary) {
        summaryData.value = listColumns.value.map(function(v, i) {
          if (v.summary) {
            v.totalSummary = props.summaryObject ? props.summaryObject[v.field] : props.list.reduce(function(pre, cur) {
              return pre + cur[v.field];
            }, 0);
          } else {
            v.totalSummary = null;
          }
          if (i === 0) {
            v.totalSummary = "\u603B\u8BA1";
          }
          return {
            totalSummary: v.totalSummary,
            width: v.width,
            align: v.align
          };
        });
      }
    };
    watch(function() {
      return props.summaryObject;
    }, function() {
      handleSummary();
    }, {
      immediate: true,
      deep: true
    });
    return {
      listColumns,
      summaryData
    };
  }
};
var _hoisted_1$9 = {
  "class": "gj-list--mini"
};
var _hoisted_2$8 = {
  "class": "gj-list--mini_header"
};
var _hoisted_3$8 = {
  key: 0,
  "class": "gj-list--mini_footer"
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$9, [createElementVNode("div", _hoisted_2$8, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.listColumns, function(columnItem) {
    return openBlock(), createElementBlock("div", {
      key: columnItem.id,
      "class": normalizeClass(["table-cell", "text-".concat(columnItem.align)]),
      style: normalizeStyle({
        width: columnItem.width
      })
    }, toDisplayString(columnItem.title), 7);
  }), 128))]), createElementVNode("ul", {
    "class": normalizeClass(["gj-list--mini_body", "is-scroll", $props.stripe && "is-stripe", $props.hover && "is-hover"]),
    style: normalizeStyle({
      maxHeight: $props.height && $props.height - 64 + "px"
    })
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.list, function(rowItem, index2) {
    return openBlock(), createElementBlock("li", {
      key: rowItem.id || index2
    }, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.listColumns, function(columnItem) {
      return openBlock(), createElementBlock("div", {
        key: columnItem.id,
        "class": normalizeClass(["table-cell", "text-".concat(columnItem.align)]),
        style: normalizeStyle({
          width: columnItem.width
        })
      }, toDisplayString(columnItem.type === "seq" ? index2 + 1 : rowItem[columnItem.field]), 7);
    }), 128))]);
  }), 128))], 6), $props.showSummary ? (openBlock(), createElementBlock("div", _hoisted_3$8, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.summaryData, function(summaryItem, index2) {
    return openBlock(), createElementBlock("div", {
      key: index2,
      "class": normalizeClass(["table-cell", "text-".concat(summaryItem.align)]),
      style: normalizeStyle({
        width: summaryItem.width
      })
    }, toDisplayString(summaryItem.totalSummary), 7);
  }), 128))])) : createCommentVNode("", true)]);
}
_sfc_main$f.render = _sfc_render$e;
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var _sfc_main$e = {
  name: "GjMergeRowTable",
  components: {
    gjPagination: _sfc_main$H,
    tableImage: _sfc_main$E
  },
  props: {
    list: {
      type: Array,
      "default": function _default31() {
        return [];
      },
      require: true
    },
    columns: {
      type: Array,
      "default": function _default32() {
        return [];
      },
      require: true
    },
    loading: {
      type: Boolean,
      "default": false
    },
    pagerConfig: {
      type: Object,
      "default": null
    },
    defaultSort: {
      type: Object,
      "default": null
    },
    selection: {
      type: Boolean,
      "default": false
    },
    childSelection: {
      type: Boolean,
      "default": false
    },
    checkExpand: {
      type: Boolean,
      "default": false
    },
    expandConfig: {
      type: Object,
      "default": null,
      require: true
    },
    onlyChildSelection: {
      type: Boolean,
      "default": false
    },
    tooltipConfig: {
      type: Object,
      "default": function _default33() {
        return {
          enterable: true,
          leaveDelay: 500
        };
      }
    },
    notExpand: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["pagerChange", "selection-change"],
  setup: function setup39(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var vxeGridRef = ref(null);
    var tableColumn = ref([]);
    var slotArr = ref([]);
    var handleColumns = function handleColumns2(columns) {
      columns.forEach(function(v) {
        if (v.suffix) {
          v.formatter = handleSuffix(v.suffix);
        }
        if (v.prefix) {
          v.formatter = handlePrefix(v.prefix);
        }
        if (!v.suffix && !v.prefix && !v.slots && !v.formatter) {
          v.formatter = handleDefaultShow();
        }
        if (v.options) {
          v.options = typeof v.options === "function" ? v.options() : v.options;
          v.formatter = handleEnum(v.options);
        }
      });
      if (props.selection) {
        var checkColumn = {
          id: "checkbox",
          field: "checkbox",
          fixed: "left",
          align: "center",
          type: "checkbox",
          width: "50px",
          slots: {
            checkbox: "check"
          },
          checked: true
        };
        if (props.childSelection) {
          checkColumn.slots.header = "headerCheck";
        }
        columns.unshift(checkColumn);
      }
      return columns;
    };
    var handleSlots = function handleSlots2(columns) {
      var alreadySlots = ["columnImage", "check", "headerCheck"];
      return getSlots(columns).filter(function(v) {
        return !alreadySlots.includes(v);
      });
    };
    watch(function() {
      return props.columns;
    }, function(newVal, oleVal) {
      tableColumn.value = handleColumns(_.cloneDeep(newVal));
      slotArr.value = handleSlots(tableColumn.value);
      if (vxeGridRef.value) {
        vxeGridRef.value.updateFooter();
      }
    }, {
      deep: true,
      immediate: true
    });
    var tableData = ref([]);
    var canSelectNum = ref(0);
    var selectRows = ref([]);
    var handleTableData = function handleTableData2(data) {
      var list = [];
      data.forEach(function(v, i) {
        v.isParent = true;
        if (props.childSelection) {
          v.indeterminate = v.indeterminate || false;
        }
        var child = v[props.expandConfig.children] || [];
        list.push(v);
        child.map(function(cv, ci) {
          cv.parentId = v.id;
          cv.isChild = true;
          return v;
        });
        child = child.filter(function(v2) {
          return !v2.isExpandRow;
        });
        if (!v.originData)
          return new Error("\u6E90\u6570\u636E\u5B57\u6BB5\u6CA1\u6709");
        if (v.originData.length > 3 && !props.notExpand) {
          if (props.expandConfig.toggleChild) {
            if (v[props.expandConfig.toggleChild]) {
              child.push(_objectSpread$2({
                isExpandRow: true
              }, v));
            }
          } else {
            child.push(_objectSpread$2({
              isExpandRow: true
            }, v));
          }
        }
        list = list.concat(child);
      });
      list.map(function(v, i) {
        v.rowId = "rId_".concat(i + 30);
        return v;
      });
      canSelectNum.value = list.filter(function(v) {
        return v.isParent && !v.isExpandRow;
      }).length;
      if (props.childSelection) {
        canSelectNum.value = list.filter(function(v) {
          return v.isParent && !v.isExpandRow;
        }).map(function(v) {
          return v.originData;
        }).flat().length;
      }
      tableData.value = list;
    };
    watch(function() {
      return props.list;
    }, function(newVal, oldval) {
      handleTableData(newVal);
    }, {
      immediate: true
    });
    var handleMerge = function handleMerge2(_ref2) {
      var row = _ref2.row, _columnIndex = _ref2._columnIndex;
      if (row.isExpandRow) {
        var startIndex = props.selection ? 1 : 0;
        var colspanLength = props.selection ? tableColumn.value.length - 1 : tableColumn.value.length;
        if (_columnIndex === startIndex) {
          return {
            rowspan: 1,
            colspan: colspanLength
          };
        } else if (_columnIndex > 1) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (row.isParent) {
        var span = props.expandConfig.span;
        if (_columnIndex === span[0]) {
          return {
            rowspan: 1,
            colspan: span[1] + 1 - span[0]
          };
        } else if (_columnIndex > span[0] && _columnIndex <= span[1]) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    };
    var handleTablePagerChange = function handleTablePagerChange2(type, val) {
      emit("pagerChange", type === "page" ? {
        page: val
      } : {
        pagesize: val
      });
    };
    var handleDefaultSort = function handleDefaultSort2() {
      if (props.defaultSort) {
        return {
          field: props.defaultSort.prop,
          order: (props.defaultSort.order || "descending").replace("ending", "")
        };
      }
      return null;
    };
    var handleRowClassName = function handleRowClassName2(_ref3) {
      var row = _ref3.row;
      _ref3.rowIndex;
      _ref3.$rowIndex;
      if (row.isExpandRow) {
        return "vxe-body--expend-row";
      }
      if (row.isParent) {
        return "vxe-body--parent-row";
      }
    };
    var handleChangeCheck = function handleChangeCheck2(row, checked, type) {
      if (!props.childSelection) {
        vxeGridRef.value.toggleCheckboxRow(row).then(function(ref2) {
          var records2 = ref2.getCheckboxRecords();
          if (records2.length === canSelectNum.value) {
            ref2.toggleAllCheckboxRow();
          }
          selectRows.value = records2;
        });
      } else {
        if (type) {
          vxeGridRef.value.setCheckboxRow(row, !checked).then(function(ref2) {
            if (checked) {
              selectRows.value = selectRows.value.filter(function(v) {
                return v.rowId !== row.rowId;
              });
            } else {
              selectRows.value.push(row);
            }
            var checkedRows = selectRows.value.filter(function(v) {
              return v.parentId === row.parentId;
            });
            var parentRow = tableData.value.filter(function(v) {
              return v.id === row.parentId;
            });
            if (checkedRows.length === parentRow[0].originData.length) {
              setIndeterminate(row, false, "parentId");
              vxeGridRef.value.setCheckboxRow(parentRow, true);
            } else {
              setIndeterminate(row, checkedRows.length > 0, "parentId");
              vxeGridRef.value.setCheckboxRow(parentRow, false);
            }
          });
        } else {
          var rows = [row].concat(_toConsumableArray(row.originData));
          var bool = row.indeterminate ? true : !checked;
          var records = selectRows.value.filter(function(v) {
            return v.parentId !== row.id;
          });
          if (props.checkExpand && !checked) {
            toggleExpand(row, true);
          }
          vxeGridRef.value.setCheckboxRow(rows, bool).then(function() {
            setIndeterminate(row, false, "id");
            if (bool) {
              records = [].concat(_toConsumableArray(records), _toConsumableArray(row.originData.map(function(v) {
                v.isChild = true;
                return v;
              })));
            }
            selectRows.value = records;
          });
        }
      }
    };
    var selectionChangeAll = function selectionChangeAll2(obj) {
      selectRows.value = obj.records.filter(function(v) {
        return v.isParent && !v.isExpandRow;
      });
    };
    var handleAllChangeCheck = function handleAllChangeCheck2(checked) {
      vxeGridRef.value.setAllCheckboxRow(!checked);
      if (!checked) {
        tableData.value.map(function(v) {
          if (v.isParent && !v.isExpandRow) {
            v.indeterminate = false;
          }
          return v;
        });
      }
      selectRows.value = checked ? [] : tableData.value.filter(function(v) {
        return v.isParent && !v.isExpandRow;
      }).map(function(v) {
        return v.originData;
      }).flat();
    };
    var setIndeterminate = function setIndeterminate2(row, bool, field) {
      tableData.value = tableData.value.map(function(v) {
        if (v.id === row[field])
          v.indeterminate = bool;
        return v;
      });
    };
    var handleResetSelection = function handleResetSelection2() {
      selectRows.value = [];
      canSelectNum.value = 0;
    };
    var toggleExpand = function toggleExpand2(row, isExpand) {
      row.isExpand = isExpand;
      if (isExpand) {
        row[props.expandConfig.children] = row.originData;
      } else {
        row[props.expandConfig.children] = row.originData.slice(0, 3);
      }
      var data = props.list.map(function(v) {
        if (v.id === row.id) {
          v.isExpand = row.isExpand;
          v[props.expandConfig.children] = row[props.expandConfig.children];
        }
        return v;
      });
      handleTableData(data);
      if (props.childSelection) {
        nextTick(function(_2) {
          var rows = selectRows.value.filter(function(v) {
            return v.parentId === row.id;
          });
          if (isExpand) {
            vxeGridRef.value.setCheckboxRow(rows, true);
          }
        });
      }
    };
    watch(selectRows, function(newVal, oldval) {
      if (newVal.length === props.canSelectNum) {
        vxeGridRef.value.setAllCheckboxRow(true);
      }
      emit("selection-change", newVal);
    });
    return {
      t,
      vxeGridRef,
      tableColumn,
      slotArr,
      tableData,
      isAllIndeterminate: computed(function() {
        return selectRows.value.length > 0 ? selectRows.value.length !== canSelectNum.value : false;
      }),
      isAllCheck: computed(function() {
        return canSelectNum.value > 0 ? selectRows.value.length === canSelectNum.value : false;
      }),
      emptyImg,
      handleMerge,
      handleTablePagerChange,
      handleDefaultSort,
      handleRowClassName,
      selectionChangeAll,
      handleAllChangeCheck,
      handleChangeCheck,
      toggleExpand,
      handleResetSelection
    };
  }
};
var _hoisted_1$8 = ["onClick"];
var _hoisted_2$7 = ["onClick"];
var _hoisted_3$7 = ["onClick"];
var _hoisted_4$4 = {
  "class": "table-pager-box"
};
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_table_image = resolveComponent("table-image");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_gj_pagination = resolveComponent("gj-pagination");
  var _component_vxe_grid = resolveComponent("vxe-grid");
  var _directive_loading = resolveDirective("loading");
  return withDirectives((openBlock(), createBlock(_component_vxe_grid, mergeProps({
    ref: "vxeGridRef"
  }, _ctx.$attrs, {
    loading: false,
    "class": "gj-merge-column-table gj-vxe-table is-scroll",
    columns: $setup.tableColumn,
    height: "auto",
    "auto-resize": "",
    "show-overflow": "",
    "row-config": {
      height: 52
    },
    round: "",
    "row-id": "rowId",
    "scroll-y": {
      mode: "wheel",
      onSize: 20
    },
    "sort-config": {
      trigger: "cell",
      defaultSort: $setup.handleDefaultSort,
      remote: true
    },
    "highlight-hover-row": "",
    "row-class-name": $setup.handleRowClassName,
    "span-method": $setup.handleMerge,
    data: $setup.tableData,
    "tooltip-config": $props.tooltipConfig,
    onCheckboxAll: $setup.selectionChangeAll
  }), createSlots({
    headerCheck: withCtx(function(_ref4) {
      var checked = _ref4.checked;
      return [!$props.onlyChildSelection ? (openBlock(), createElementBlock("span", {
        key: 0,
        "class": "item-checkbox",
        onClick: withModifiers(function($event) {
          return $setup.handleAllChangeCheck(checked);
        }, ["stop"])
      }, [createElementVNode("i", {
        "class": normalizeClass([$setup.isAllCheck && "is-checked", $setup.isAllIndeterminate && "is-indeterminate"])
      }, null, 2)], 8, _hoisted_1$8)) : createCommentVNode("", true)];
    }),
    check: withCtx(function(_ref5) {
      var row = _ref5.row, checked = _ref5.checked;
      return [row.isParent && !row.isExpandRow && !$props.onlyChildSelection ? (openBlock(), createElementBlock("span", {
        key: 0,
        "class": "item-checkbox",
        onClick: withModifiers(function($event) {
          return $setup.handleChangeCheck(row, checked);
        }, ["stop"])
      }, [createElementVNode("i", {
        "class": normalizeClass([checked && "is-checked", row.indeterminate && "is-indeterminate"])
      }, null, 2)], 8, _hoisted_2$7)) : createCommentVNode("", true), row.isChild && $props.childSelection ? (openBlock(), createElementBlock("span", {
        key: 1,
        "class": "item-checkbox",
        onClick: withModifiers(function($event) {
          return $setup.handleChangeCheck(row, checked, "child");
        }, ["stop"])
      }, [createElementVNode("i", {
        "class": normalizeClass([checked && "is-checked"])
      }, null, 2)], 8, _hoisted_3$7)) : createCommentVNode("", true)];
    }),
    columnImage: withCtx(function(_ref6) {
      var row = _ref6.row, column = _ref6.column;
      return [createVNode(_component_table_image, {
        src: row[column.property]
      }, null, 8, ["src"])];
    }),
    empty: withCtx(function() {
      return [createVNode(_component_el_empty, {
        image: $setup.emptyImg,
        "image-size": 200,
        text: $setup.t("gj.emptyText")
      }, null, 8, ["image", "text"])];
    }),
    _: 2
  }, [renderList($setup.slotArr, function(item) {
    return {
      name: item,
      fn: withCtx(function(props) {
        return [renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(props)))];
      })
    };
  }), $props.pagerConfig && $setup.tableData.length > 0 ? {
    name: "pager",
    fn: withCtx(function() {
      return [createElementVNode("div", _hoisted_4$4, [createVNode(_component_gj_pagination, {
        "current-page": $props.pagerConfig.page,
        "page-size": $props.pagerConfig.pagesize,
        total: $props.pagerConfig.total,
        background: $props.pagerConfig.background !== false,
        layout: $props.pagerConfig.layout || "total,sizes,prev,pager,next,jumper",
        onSizeChange: _cache[0] || (_cache[0] = function($event) {
          return $setup.handleTablePagerChange("pagesize", $event);
        }),
        onCurrentChange: _cache[1] || (_cache[1] = function($event) {
          return $setup.handleTablePagerChange("page", $event);
        })
      }, null, 8, ["current-page", "page-size", "total", "background", "layout"])])];
    })
  } : void 0]), 1040, ["columns", "sort-config", "row-class-name", "span-method", "data", "tooltip-config", "onCheckboxAll"])), [[_directive_loading, $props.loading]]);
}
_sfc_main$e.render = _sfc_render$d;
var _sfc_main$d = {
  name: "GjMergeColumnTable",
  components: {
    gjPagination: _sfc_main$H,
    tableImage: _sfc_main$E
  },
  props: {
    columns: {
      type: Array,
      "default": function _default34() {
        return [];
      },
      required: true
    },
    isSeq: {
      type: Boolean,
      "default": false
    },
    selection: {
      type: Boolean,
      "default": false
    },
    checkboxConfig: {
      type: Object,
      "default": null
    },
    list: {
      type: Array,
      "default": function _default35() {
        return [];
      },
      required: true
    },
    loading: {
      type: Boolean,
      "default": false
    },
    showSummary: {
      type: Boolean,
      "default": false
    },
    summaryObject: {
      type: Object,
      "default": function _default36() {
      }
    },
    defaultSort: {
      type: Object,
      "default": null
    },
    pagerConfig: {
      type: Object,
      "default": null
    },
    mergeObject: {
      type: Object,
      "default": function _default37() {
        return {
          children: "items",
          colspanIndex: 0,
          colspanField: "id"
        };
      }
    },
    tooltipConfig: {
      type: Object,
      "default": function _default38() {
        return {
          enterable: true,
          leaveDelay: 500
        };
      }
    }
  },
  emits: ["pagerChange", "checkbox-change", "sort-change"],
  setup: function setup40(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t, lang = _useLocale.lang;
    var vxeGridRef = ref(null);
    var tableData = computed(function() {
      return handleData(props.list);
    });
    var alreadySlots = ["columnImage", "childTable"];
    var slotArr = computed(function() {
      return getSlots(props.columns).filter(function(v) {
        return !alreadySlots.includes(v);
      });
    });
    var handleFooterMethod = function handleFooterMethod2(_ref2) {
      _ref2.columns;
      _ref2.data;
      if (isMeaningful(props.summaryObject)) {
        var arr = tableColumn.value.map(function(v) {
          if (v.summary) {
            var summaryNum = props.summaryObject[v.id];
            if (isMeaningful(summaryNum)) {
              if (v.suffix) {
                summaryNum = "".concat(summaryNum).concat(v.suffix);
              }
            }
            v.summaryNum = summaryNum;
          }
          return v.summaryNum;
        });
        arr[0] = lang.value === "en" ? "Sum" : "\u5408\u8BA1";
        return [arr];
      } else {
        return [[]];
      }
    };
    var handleDefaultSort = function handleDefaultSort2() {
      if (props.defaultSort) {
        return {
          field: props.defaultSort.prop,
          order: (props.defaultSort.order || "descending").replace("ending", "")
        };
      }
      return null;
    };
    var handleColumns = function handleColumns2(columns) {
      columns = handleFormatter(columns);
      if (props.isSeq && !columns.some(function(v) {
        return v.type === "seq";
      }) && !columns.some(function(v) {
        return v.field === "index";
      })) {
        columns.unshift({
          id: "index",
          field: "index",
          title: "\u5E8F\u53F7",
          width: "55px",
          fixed: "left"
        });
      }
      if (props.selection && !columns.some(function(v) {
        return v.type === "checkbox";
      })) {
        columns.unshift({
          id: "checkbox",
          field: "checkbox",
          type: "checkbox",
          align: "center",
          width: "45px",
          fixed: "left"
        });
      }
      return columns;
    };
    var tableColumn = ref([]);
    watch(function() {
      return props.columns;
    }, function(newVal, oleVal) {
      tableColumn.value = handleColumns(_.cloneDeep(newVal));
      if (vxeGridRef.value) {
        vxeGridRef.value.updateFooter();
      }
    }, {
      deep: true,
      immediate: true
    });
    var handleTablePagerChange = function handleTablePagerChange2(type, val) {
      emit("pagerChange", type === "page" ? {
        page: val
      } : {
        pagesize: val
      });
    };
    var handleCheckboxChange = function handleCheckboxChange2(val) {
      return emit("checkbox-change", val);
    };
    var handleSortChange = function handleSortChange2(val) {
      return emit("sort-change", val);
    };
    var handleData = function handleData2() {
      var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return data.map(function(v) {
        var items = _.cloneDeep(v[props.mergeObject.children] || []);
        delete v[props.mergeObject.children];
        var parentInfo = v;
        items.map(function(cv) {
          cv.parentInfo = parentInfo;
          cv.parentId = parentInfo[props.mergeObject.colspanField];
          return cv;
        });
        return items;
      }).flat();
    };
    var rowspanMethod = function rowspanMethod2(_ref3) {
      var row = _ref3.row, _rowIndex = _ref3._rowIndex, column = _ref3.column, visibleData = _ref3.visibleData;
      var fields = ["parentId"];
      var cellValue = row[column.property];
      if (cellValue && fields.includes(column.property)) {
        var prevRow = visibleData[_rowIndex - 1];
        var nextRow = visibleData[_rowIndex + 1];
        if (prevRow && prevRow[column.property] === cellValue) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          var countRowspan = 1;
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return {
              rowspan: countRowspan,
              colspan: 1
            };
          }
        }
      }
    };
    var handleCellClassName = function handleCellClassName2(_ref4) {
      var columnIndex = _ref4.columnIndex;
      if (columnIndex === props.mergeObject.colspanIndex) {
        return "vxe-body--merge-cell";
      }
    };
    var handleFooterClassName = function handleFooterClassName2(_ref5) {
      var columnIndex = _ref5.columnIndex;
      if (columnIndex === props.mergeObject.colspanIndex) {
        return "vxe-footer--merge-cell";
      }
    };
    return {
      t,
      vxeGridRef,
      tableData,
      tableColumn,
      slotArr,
      emptyImg,
      handleDefaultSort,
      handleFooterMethod,
      handleTablePagerChange,
      handleCheckboxChange,
      handleSortChange,
      rowspanMethod,
      handleCellClassName,
      handleFooterClassName
    };
  }
};
var _hoisted_1$7 = {
  "class": "table-pager-box"
};
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_table_image = resolveComponent("table-image");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_gj_pagination = resolveComponent("gj-pagination");
  var _component_vxe_grid = resolveComponent("vxe-grid");
  var _directive_loading = resolveDirective("loading");
  return withDirectives((openBlock(), createBlock(_component_vxe_grid, mergeProps(_ctx.$attrs, {
    ref: "vxeGridRef",
    data: $setup.tableData,
    height: "auto",
    "auto-resize": "",
    "show-overflow": "",
    "row-config": {
      height: 52
    },
    round: "",
    "highlight-hover-row": "",
    "scroll-y": {
      gt: 100,
      enabled: true,
      mode: "wheel",
      onSize: 20
    },
    loading: false,
    "show-footer": $props.showSummary && $setup.tableData.length > 0,
    "footer-method": $setup.handleFooterMethod,
    columns: $setup.tableColumn,
    "tooltip-config": $props.tooltipConfig,
    "sort-config": {
      trigger: "cell",
      defaultSort: $setup.handleDefaultSort,
      remote: true
    },
    "checkbox-config": $props.checkboxConfig,
    "class": "gj-vxe-table gj-merge-column-table is-scroll",
    "cell-class-name": $setup.handleCellClassName,
    "footer-cell-class-name": $setup.handleFooterClassName,
    "span-method": $setup.rowspanMethod,
    onCheckboxChange: $setup.handleCheckboxChange,
    onCheckboxAll: $setup.handleCheckboxChange,
    onSortChange: $setup.handleSortChange
  }), createSlots({
    columnImage: withCtx(function(_ref6) {
      var row = _ref6.row, column = _ref6.column;
      return [createVNode(_component_table_image, {
        src: row[column.property]
      }, null, 8, ["src"])];
    }),
    empty: withCtx(function() {
      return [createVNode(_component_el_empty, {
        image: $setup.emptyImg,
        "image-size": 200,
        text: $setup.t("gj.emptyText")
      }, null, 8, ["image", "text"])];
    }),
    _: 2
  }, [renderList($setup.slotArr, function(item) {
    return {
      name: item,
      fn: withCtx(function(props) {
        return [renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(props)))];
      })
    };
  }), $props.pagerConfig && $setup.tableData.length > 0 ? {
    name: "pager",
    fn: withCtx(function() {
      return [createElementVNode("div", _hoisted_1$7, [createVNode(_component_gj_pagination, {
        "current-page": $props.pagerConfig.page,
        "page-size": $props.pagerConfig.pagesize,
        total: $props.pagerConfig.total,
        background: $props.pagerConfig.background !== false,
        layout: $props.pagerConfig.layout || "total,sizes,prev,pager,next,jumper",
        onSizeChange: _cache[0] || (_cache[0] = function($event) {
          return $setup.handleTablePagerChange("pagesize", $event);
        }),
        onCurrentChange: _cache[1] || (_cache[1] = function($event) {
          return $setup.handleTablePagerChange("page", $event);
        })
      }, null, 8, ["current-page", "page-size", "total", "background", "layout"])])];
    })
  } : void 0]), 1040, ["data", "show-footer", "footer-method", "columns", "tooltip-config", "sort-config", "checkbox-config", "cell-class-name", "footer-cell-class-name", "span-method", "onCheckboxChange", "onCheckboxAll", "onSortChange"])), [[_directive_loading, $props.loading]]);
}
_sfc_main$d.render = _sfc_render$c;
var drapImg = "data:image/png;base64,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";
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var version = "1.14.0";
function userAgent(pattern) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector)
    return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx)
        break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window)
    return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container, "border-top-width"));
          left -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible)
      return parent;
    if (parent === getWindowScrollingElement())
      break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i = 0, children = el.children;
  while (i < children.length) {
    if (children[i].style.display !== "none" && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index$1(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i))
      continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key])
        return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect)
    return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body)
          return getWindowScrollingElement();
        if (gotSelf || includeSelf)
          return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation)
        return;
      var children = [].slice.call(this.el.children);
      children.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost)
          return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function")
          callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function")
          callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function")
            callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults[option2];
      }
    }
    plugins.forEach(function(p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault)
        return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2))
        continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function")
        return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable)
    return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists)
    return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x, y) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable))
      return;
    var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: false,
    invertedSwapThreshold: null,
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = {
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable)
      return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index$1(target);
    oldDraggableIndex = index$1(target, options.draggable);
    if (typeof filter === "function") {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent2("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter) {
      filter = filter.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent2("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent2("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this._onDrop);
      on(ownerDocument, "touchend", _this._onDrop);
      on(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent2("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on(ownerDocument, "touchend", _this._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent2("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent)
          break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = parent.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document)
            ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent2("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent2("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent2("clone", _this);
      if (Sortable.eventCanceled)
        return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent)
      return;
    function dragOverEvent(name, extra) {
      pluginEvent2(name, _this, _objectSpread2({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index$1(dragEl);
      newDraggableIndex = index$1(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled)
      return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled)
        return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index$1(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);
    pluginEvent2("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent2("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  toArray: function toArray() {
    var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
    for (; i < n; i++) {
      el = children[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i) {
      var el = rootEl2.children[i];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  destroy: function destroy() {
    pluginEvent2("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent2("hideClone", this);
      if (Sortable.eventCanceled)
        return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent2("showClone", this);
      if (Sortable.eventCanceled)
        return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index$1(dragEl) < index$1(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend,
  throttle,
  closest,
  toggleClass,
  clone,
  index: index$1,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array)
    plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils)
      Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll)
    return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent)
    return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
var _sfc_main$c = {
  name: "GjDragRowTable",
  components: {
    tableImage: _sfc_main$E,
    gjPagination: _sfc_main$H
  },
  props: {
    list: {
      type: Array,
      "default": function _default39() {
        return [];
      },
      require: true
    },
    loading: {
      type: Boolean,
      "default": false
    },
    columns: {
      type: Array,
      "default": function _default40() {
        return [];
      },
      require: true
    },
    pagerConfig: {
      type: Object,
      "default": null
    },
    selection: {
      type: Boolean,
      "default": false
    },
    tooltipConfig: {
      type: Object,
      "default": function _default41() {
        return {
          enterable: true,
          leaveDelay: 500
        };
      }
    }
  },
  emits: ["update:list", "checkbox-change"],
  setup: function setup41(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var vxeGridRef = ref(null);
    var alreadySlots = ["columnImage", "drag"];
    var slotArr = computed(function() {
      return getSlots(props.columns).filter(function(v) {
        return !alreadySlots.includes(v);
      });
    });
    var handleColumns = function handleColumns2(columns) {
      columns = handleFormatter(columns);
      if (props.selection && !columns.some(function(v) {
        return v.type === "checkbox";
      })) {
        columns.unshift({
          id: "checkbox",
          field: "checkbox",
          type: "checkbox",
          width: "45px",
          fixed: "left"
        });
      }
      columns.unshift({
        id: "drag",
        field: "drag",
        width: "50px",
        fixed: "left",
        slots: {
          "default": "drag"
        }
      });
      return columns;
    };
    var tableColumn = ref([]);
    watch(function() {
      return props.columns;
    }, function(newVal, oleVal) {
      tableColumn.value = handleColumns(_.cloneDeep(newVal));
    }, {
      deep: true,
      immediate: true
    });
    var tableData = ref([]);
    watch(function() {
      return props.list;
    }, function(newVal, oldVal) {
      tableData.value = newVal;
    });
    var sortable1 = null;
    var rowDrop = function rowDrop2() {
      var $table = vxeGridRef.value;
      sortable1 = Sortable.create($table.$el.querySelector(".body--wrapper>.vxe-table--body tbody"), {
        handle: ".drag-btn",
        onEnd: function onEnd(sortableEvent) {
          var newIndex2 = sortableEvent.newIndex;
          var oldIndex2 = sortableEvent.oldIndex;
          var currRow = tableData.value.splice(oldIndex2, 1)[0];
          tableData.value.splice(newIndex2, 0, currRow);
          emit("update:list", tableData.value);
        }
      });
    };
    var initTime = null;
    nextTick(function() {
      initTime = setTimeout(function() {
        rowDrop();
      }, 500);
    });
    var handleCheckboxChange = function handleCheckboxChange2(val) {
      return emit("checkbox-change", val);
    };
    onUnmounted(function() {
      clearTimeout(initTime);
      if (sortable1) {
        sortable1.destroy();
      }
    });
    return {
      t,
      emptyImg,
      drapImg,
      slotArr,
      tableColumn,
      tableData,
      vxeGridRef,
      handleCheckboxChange
    };
  }
};
var _hoisted_1$6 = {
  "class": "drag-btn"
};
var _hoisted_2$6 = ["src"];
var _hoisted_3$6 = {
  "class": "table-pager-box"
};
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_table_image = resolveComponent("table-image");
  var _component_el_empty = resolveComponent("el-empty");
  var _component_gj_pagination = resolveComponent("gj-pagination");
  var _component_vxe_grid = resolveComponent("vxe-grid");
  var _directive_loading = resolveDirective("loading");
  return withDirectives((openBlock(), createBlock(_component_vxe_grid, mergeProps({
    ref: "vxeGridRef"
  }, _ctx.$attrs, {
    loading: false,
    "class": "gj-drag-row-table gj-vxe-table is-scroll",
    columns: $setup.tableColumn,
    height: "auto",
    "auto-resize": "",
    "show-overflow": "",
    "row-config": {
      height: 52
    },
    round: "",
    "row-id": "rowId",
    "highlight-hover-row": "",
    data: $setup.tableData,
    "tooltip-config": $props.tooltipConfig,
    onCheckboxChange: $setup.handleCheckboxChange,
    onCheckboxAll: $setup.handleCheckboxChange
  }), createSlots({
    drag: withCtx(function() {
      return [createElementVNode("div", _hoisted_1$6, [createElementVNode("img", {
        src: $setup.drapImg,
        alt: "/"
      }, null, 8, _hoisted_2$6)])];
    }),
    columnImage: withCtx(function(_ref2) {
      var row = _ref2.row, column = _ref2.column;
      return [createVNode(_component_table_image, {
        src: row[column.property]
      }, null, 8, ["src"])];
    }),
    empty: withCtx(function() {
      return [createVNode(_component_el_empty, {
        image: $setup.emptyImg,
        "image-size": 200,
        text: $setup.t("gj.emptyText")
      }, null, 8, ["image", "text"])];
    }),
    _: 2
  }, [renderList($setup.slotArr, function(item) {
    return {
      name: item,
      fn: withCtx(function(props) {
        return [renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(props)))];
      })
    };
  }), $props.pagerConfig && $setup.tableData.length > 0 ? {
    name: "pager",
    fn: withCtx(function() {
      return [createElementVNode("div", _hoisted_3$6, [createVNode(_component_gj_pagination, {
        "current-page": $props.pagerConfig.page,
        "page-size": $props.pagerConfig.pagesize,
        total: $props.pagerConfig.total,
        background: $props.pagerConfig.background !== false,
        layout: $props.pagerConfig.layout || "total,sizes,prev,pager,next,jumper",
        onSizeChange: _cache[0] || (_cache[0] = function($event) {
          return _ctx.handleTablePagerChange("pagesize", $event);
        }),
        onCurrentChange: _cache[1] || (_cache[1] = function($event) {
          return _ctx.handleTablePagerChange("page", $event);
        })
      }, null, 8, ["current-page", "page-size", "total", "background", "layout"])])];
    })
  } : void 0]), 1040, ["columns", "data", "tooltip-config", "onCheckboxChange", "onCheckboxAll"])), [[_directive_loading, $props.loading]]);
}
_sfc_main$c.render = _sfc_render$b;
var GjVxeTable = withInstall(_sfc_main$g, {
  miniList: _sfc_main$f,
  mergeRowTable: _sfc_main$e,
  mergeColumnTable: _sfc_main$d,
  dragRowTable: _sfc_main$c
});
var GjMiniList = withNoopInstall(_sfc_main$f);
var GjMergeRowTable = withNoopInstall(_sfc_main$e);
var GjMergeColumnTable = withNoopInstall(_sfc_main$d);
var GjDragRowTable = withNoopInstall(_sfc_main$c);
var _sfc_main$b = {
  name: "GjText",
  props: {
    isTooltip: {
      type: Boolean,
      "default": true
    },
    isCopy: {
      type: Boolean,
      "default": true
    },
    textLine: {
      type: Number
    },
    width: {
      type: Number
    }
  },
  setup: function setup42(props, _ref) {
    var slots = _ref.slots;
    var handleClick = function handleClick2() {
      var text = slots["default"]()[0].children;
      if (!text)
        return;
      if (!document.getElementById("copyTarget")) {
        var copyTarget = document.createElement("input");
        copyTarget.setAttribute("style", "position:fixed;top:0;left:0;opacity:0;z-index:-1000;");
        copyTarget.setAttribute("id", "copyTarget");
        document.body.appendChild(copyTarget);
      }
      var input = document.getElementById("copyTarget");
      input.value = text;
      input.select();
      document.execCommand("copy");
      ElMessage.success("\u590D\u5236\u6210\u529F");
    };
    return {
      currentStyle: computed(function() {
        var style = {};
        if (props.textLine) {
          style["line-clamp"] = props.textLine;
        }
        if (props.width) {
          style.width = props.isCopy ? props.width - 14 + "px" : props.width + "px";
        }
        return style;
      }),
      currentClassName: computed(function() {
        var str = "gj-tooltip";
        if (props.popperClass) {
          str = "".concat(str, " ").concat(props.popperClass);
        }
        return str;
      }),
      currentWidth: computed(function() {
        return props.width ? {
          width: props.width + "px"
        } : {
          width: "auto"
        };
      }),
      handleClick
    };
  }
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = resolveComponent("el-tooltip");
  return $props.isTooltip ? (openBlock(), createBlock(_component_el_tooltip, mergeProps({
    key: 0
  }, _ctx.$attrs, {
    "popper-class": $setup.currentClassName,
    "show-after": 400
  }), createSlots({
    "default": withCtx(function() {
      return [createElementVNode("div", {
        "class": "gj-text",
        style: normalizeStyle($setup.currentWidth)
      }, [createElementVNode("div", {
        "class": normalizeClass([$props.textLine && "gj-tooltip--textLine", "gj-text__content"]),
        style: normalizeStyle($setup.currentStyle)
      }, [renderSlot(_ctx.$slots, "default")], 6), $props.isCopy ? (openBlock(), createElementBlock("i", {
        key: 0,
        "class": "el-icon-copy-document",
        onClick: _cache[0] || (_cache[0] = function() {
          return $setup.handleClick && $setup.handleClick.apply($setup, arguments);
        })
      })) : createCommentVNode("", true)], 4)];
    }),
    _: 2
  }, [_ctx.$slots.content ? {
    name: "content",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "content")];
    })
  } : void 0]), 1040, ["popper-class"])) : (openBlock(), createElementBlock("div", {
    key: 1,
    "class": "gj-text",
    style: normalizeStyle($setup.currentWidth)
  }, [createElementVNode("div", {
    "class": normalizeClass([$props.textLine && "gj-tooltip--textLine", "gj-text__content"]),
    style: normalizeStyle($setup.currentStyle)
  }, [renderSlot(_ctx.$slots, "default")], 6), $props.isCopy ? (openBlock(), createElementBlock("i", {
    key: 0,
    "class": "el-icon-copy-document",
    onClick: _cache[1] || (_cache[1] = function() {
      return $setup.handleClick && $setup.handleClick.apply($setup, arguments);
    })
  })) : createCommentVNode("", true)], 4));
}
_sfc_main$b.render = _sfc_render$a;
var GjText = withInstall(_sfc_main$b);
var _sfc_main$a = {
  name: "GjTimeline",
  setup: function setup43(_2, ctx) {
    provide("timeline", ctx);
    return function() {
      var _ctx$slots$default, _ctx$slots;
      return h("ul", {
        "class": {
          "gj-timeline": true
        }
      }, (_ctx$slots$default = (_ctx$slots = ctx.slots)["default"]) === null || _ctx$slots$default === void 0 ? void 0 : _ctx$slots$default.call(_ctx$slots));
    };
  }
};
var _sfc_main$9 = {
  name: "GjTimelineItem",
  props: {
    title: {
      type: String,
      "default": null
    },
    type: {
      type: String,
      "default": ""
    },
    color: {
      type: String,
      "default": ""
    },
    size: {
      type: String,
      "default": "normal"
    },
    icon: {
      type: String,
      "default": null
    },
    hollow: {
      type: Boolean,
      "default": false
    },
    leftWidth: {
      type: Number,
      "default": 45
    }
  },
  setup: function setup44() {
    inject("timeline");
  }
};
var _hoisted_1$5 = {
  "class": "gj-timeline-item"
};
var _hoisted_2$5 = {
  key: 0,
  "class": "gj-timeline-item__dot"
};
var _hoisted_3$5 = {
  key: 0,
  "class": "gj-timeline-item__title"
};
var _hoisted_4$3 = {
  "class": "gj-timeline-item__content"
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", _hoisted_1$5, [createElementVNode("div", {
    "class": "gj-timeline-item__tail",
    style: normalizeStyle({
      left: _ctx.$slots.left ? $props.leftWidth + ($props.size === "large" ? 7 : 6) + "px" : ($props.size === "large" ? 7 : 6) + "px"
    })
  }, null, 4), _ctx.$slots.dot ? (openBlock(), createElementBlock("div", _hoisted_2$5, [renderSlot(_ctx.$slots, "dot")])) : (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass(["gj-timeline-item__node", [$props.size && "gj-timeline-item__node--".concat($props.size), $props.type && "gj-timeline-item__node--".concat($props.type), $props.hollow ? "is-hollow" : ""]]),
    style: normalizeStyle({
      backgroundColor: $props.color,
      borderColor: $props.color,
      left: _ctx.$slots.left ? $props.leftWidth + "px" : ""
    })
  }, [_ctx.$slots.icon ? renderSlot(_ctx.$slots, "icon", {
    key: 0
  }) : createCommentVNode("", true), $props.icon ? (openBlock(), createElementBlock("i", {
    key: 1,
    "class": normalizeClass([$props.icon, "gj-timeline-item__icon"])
  }, null, 2)) : createCommentVNode("", true)], 6)), createElementVNode("div", {
    "class": "gj-timeline-item__right-wrapper",
    style: normalizeStyle({
      paddingLeft: _ctx.$slots.left ? $props.leftWidth + 24 + "px" : ""
    })
  }, [$props.title ? (openBlock(), createElementBlock("div", _hoisted_3$5, toDisplayString($props.title), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_4$3, [renderSlot(_ctx.$slots, "default")])], 4), _ctx.$slots.left ? (openBlock(), createElementBlock("div", {
    key: 2,
    "class": "gj-timeline-item__left-wrapper",
    style: normalizeStyle({
      width: $props.leftWidth + "px"
    })
  }, [renderSlot(_ctx.$slots, "left")], 4)) : createCommentVNode("", true)]);
}
_sfc_main$9.render = _sfc_render$9;
var GjTimeline = withInstall(_sfc_main$a, {
  timelineItem: _sfc_main$9
});
var GjTimelineItem = withNoopInstall(_sfc_main$9);
var _sfc_main$8 = {
  name: "GjTooltip",
  props: {
    textLine: {
      type: Number,
      "default": null
    },
    width: {
      type: Number,
      "default": null
    }
  },
  setup: function setup45(props) {
    return {
      textLineStyle: computed(function() {
        if (!props.textLine)
          return null;
        return {
          "-webkit-line-clamp": props.textLine
        };
      }),
      widthStyle: computed(function() {
        return {
          width: props.width + "px"
        };
      })
    };
  }
};
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = resolveComponent("el-tooltip");
  return openBlock(), createBlock(_component_el_tooltip, mergeProps(_ctx.$attrs, {
    "show-after": 400,
    "popper-class": "gj-tooltip"
  }), createSlots({
    "default": withCtx(function() {
      return [$props.textLine || $props.width ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass([$props.textLine && "gj-tooltip-default"]),
        style: normalizeStyle([$props.textLine && $setup.textLineStyle, $props.width && $setup.widthStyle])
      }, [renderSlot(_ctx.$slots, "default")], 6)) : renderSlot(_ctx.$slots, "default", {
        key: 1
      })];
    }),
    _: 2
  }, [_ctx.$slots.content ? {
    name: "content",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "content")];
    })
  } : void 0]), 1040);
}
_sfc_main$8.render = _sfc_render$8;
var _sfc_main$7 = {
  name: "GjTooltipIcon",
  props: {
    icon: {
      type: String,
      "default": "el-icon-question"
    }
  }
};
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = resolveComponent("el-tooltip");
  return openBlock(), createBlock(_component_el_tooltip, mergeProps(_ctx.$attrs, {
    "show-after": 400,
    "popper-class": "gj-tooltip"
  }), createSlots({
    "default": withCtx(function() {
      return [_ctx.$slots.icon ? renderSlot(_ctx.$slots, "icon", {
        key: 0
      }) : (openBlock(), createElementBlock("i", {
        key: 1,
        "class": normalizeClass([$props.icon, "gj-tooltip--icon"])
      }, null, 2))];
    }),
    _: 2
  }, [_ctx.$slots.content ? {
    name: "content",
    fn: withCtx(function() {
      return [renderSlot(_ctx.$slots, "content")];
    })
  } : void 0]), 1040);
}
_sfc_main$7.render = _sfc_render$7;
var GjTooltip = withInstall(_sfc_main$8, {
  tooltipIcon: _sfc_main$7
});
var GjTooltipIcon = withNoopInstall(_sfc_main$7);
var _sfc_main$6 = {
  name: "GjTransfer"
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_transfer = resolveComponent("el-transfer");
  return openBlock(), createBlock(_component_el_transfer, mergeProps(_ctx.$attrs, {
    "class": ["gj-transfer"]
  }), null, 16);
}
_sfc_main$6.render = _sfc_render$6;
var GjTransfer = withInstall(_sfc_main$6);
var _sfc_main$5 = {
  name: "GjTree"
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tree = resolveComponent("el-tree");
  return openBlock(), createBlock(_component_el_tree, mergeProps(_ctx.$attrs, {
    ref: "tree",
    "highlight-current": "",
    "class": "gj-tree"
  }), null, 16);
}
_sfc_main$5.render = _sfc_render$5;
var GjTree = withInstall(_sfc_main$5);
var _sfc_main$4 = {
  name: "GjTableBaseLayout",
  props: {
    asideWidth: {
      type: Number,
      "default": 200
    },
    leftWidth: {
      type: Number,
      "default": 0
    },
    layout: {
      type: String,
      "default": "row"
    }
  }
};
var _hoisted_1$4 = {
  "class": "gj_layout_base"
};
var _hoisted_2$4 = {
  "class": "gj_layout_base__header"
};
var _hoisted_3$4 = {
  "class": "gj_layout_base__section"
};
var _hoisted_4$2 = {
  "class": "gj_layout_base__content"
};
var _hoisted_5$2 = {
  "class": "table-box"
};
var _hoisted_6 = {
  "class": "gj_layout_base__section"
};
var _hoisted_7 = {
  "class": "gj_layout_base__header"
};
var _hoisted_8 = {
  "class": "gj_layout_base__content"
};
var _hoisted_9 = {
  "class": "table-box"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [createElementVNode("div", {
    "class": normalizeClass("gj_layout_base__wrap gj_layout_base__wrap--".concat($props.layout))
  }, [$props.layout === "row" ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("header", _hoisted_2$4, [renderSlot(_ctx.$slots, "header")]), createElementVNode("section", _hoisted_3$4, [_ctx.$slots.left || _ctx.$slots.aside ? (openBlock(), createElementBlock("aside", {
    key: 0,
    "class": "gj_layout_base__aside",
    style: normalizeStyle({
      width: ($props.leftWidth || $props.asideWidth) + "px"
    })
  }, [renderSlot(_ctx.$slots, "left"), renderSlot(_ctx.$slots, "aside")], 4)) : createCommentVNode("", true), createElementVNode("div", _hoisted_4$2, [renderSlot(_ctx.$slots, "default"), createElementVNode("div", _hoisted_5$2, [renderSlot(_ctx.$slots, "table")])])])], 64)) : $props.layout === "column" ? (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [_ctx.$slots.left || _ctx.$slots.aside ? (openBlock(), createElementBlock("aside", {
    key: 0,
    "class": "gj_layout_base__aside",
    style: normalizeStyle({
      width: $props.asideWidth + "px"
    })
  }, [renderSlot(_ctx.$slots, "left"), renderSlot(_ctx.$slots, "aside")], 4)) : createCommentVNode("", true), createElementVNode("section", _hoisted_6, [createElementVNode("header", _hoisted_7, [renderSlot(_ctx.$slots, "header")]), createElementVNode("div", _hoisted_8, [renderSlot(_ctx.$slots, "default"), createElementVNode("div", _hoisted_9, [renderSlot(_ctx.$slots, "table")])])])], 64)) : createCommentVNode("", true)], 2)]);
}
_sfc_main$4.render = _sfc_render$4;
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$3 = defineComponent({
  name: "Refresh"
});
const _hoisted_1$3 = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M771.776 794.88A384 384 0 01128 512h64a320 320 0 00555.712 216.448H654.72a32 32 0 110-64h149.056a32 32 0 0132 32v148.928a32 32 0 11-64 0v-50.56zM276.288 295.616h92.992a32 32 0 010 64H220.16a32 32 0 01-32-32V178.56a32 32 0 0164 0v50.56A384 384 0 01896.128 512h-64a320 320 0 00-555.776-216.384z"
}, null, -1);
const _hoisted_3$3 = [
  _hoisted_2$3
];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$3, _hoisted_3$3);
}
var refresh = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = defineComponent({
  name: "View"
});
const _hoisted_1$2 = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$2 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 110 448 224 224 0 010-448zm0 64a160.192 160.192 0 00-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z"
}, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$2
];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$2, _hoisted_3$2);
}
var view = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
var _sfc_main$1 = {
  name: "GjTableSearchLayout",
  components: {
    GjButton,
    GjButtonIcon,
    GjBadge,
    View: view,
    GjSvgIcon
  },
  props: {
    layout: {
      type: Array,
      "default": function _default42() {
        return [];
      }
    },
    highNum: Number
  },
  emits: ["click-search", "click-reset"],
  setup: function setup46(props, _ref) {
    var emit = _ref.emit;
    var _useLocale = useLocale(), t = _useLocale.t;
    var handleSearch = function handleSearch2() {
      return emit("click-search");
    };
    var handleReset = function handleReset2() {
      return emit("click-reset");
    };
    var isMore = ref(false);
    return {
      handleReset,
      handleSearch,
      isMore,
      t
    };
  }
};
var _hoisted_1$1 = {
  "class": "gj_table-search-bar"
};
var _hoisted_2$1 = {
  "class": "gj_table-search-bar__left"
};
var _hoisted_3$1 = {
  "class": "gj_table-search-bar__right"
};
var _hoisted_4$1 = {
  "class": "slot-right"
};
var _hoisted_5$1 = {
  key: 0,
  "class": "gj_table-search-bar__expand"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_svg_icon = resolveComponent("gj-svg-icon");
  var _component_gj_button_icon = resolveComponent("gj-button-icon");
  var _component_gj_badge = resolveComponent("gj-badge");
  var _component_gj_button = resolveComponent("gj-button");
  var _component_View = resolveComponent("View");
  return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", _hoisted_1$1, [createElementVNode("div", _hoisted_2$1, [renderSlot(_ctx.$slots, "default")]), createElementVNode("div", _hoisted_3$1, [$props.layout.includes("high") ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [$props.highNum ? (openBlock(), createBlock(_component_gj_badge, {
    key: 0,
    value: $props.highNum,
    max: 99,
    type: "primary"
  }, {
    "default": withCtx(function() {
      return [createVNode(_component_gj_button_icon, {
        "class": normalizeClass(["gj-svg-button", $setup.isMore && "gj-button--icon-focus"]),
        onClick: _cache[0] || (_cache[0] = function($event) {
          return $setup.isMore = !$setup.isMore;
        })
      }, {
        "default": withCtx(function() {
          return [createVNode(_component_gj_svg_icon, {
            name: "gaojishanxuan",
            size: 18
          })];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  }, 8, ["value"])) : (openBlock(), createBlock(_component_gj_button_icon, {
    key: 1,
    "class": normalizeClass(["gj-svg-button", $setup.isMore && "gj-button--icon-focus", !$setup.isMore && "gj-button--icon-normal"]),
    onClick: _cache[1] || (_cache[1] = function($event) {
      return $setup.isMore = !$setup.isMore;
    })
  }, {
    "default": withCtx(function() {
      return [createVNode(_component_gj_svg_icon, {
        name: "gaojishanxuan",
        size: 18
      })];
    }),
    _: 1
  }, 8, ["class"]))], 64)) : createCommentVNode("", true), $props.layout.includes("search") ? (openBlock(), createBlock(_component_gj_button, {
    key: 1,
    type: "primary",
    onClick: $setup.handleSearch
  }, {
    "default": withCtx(function() {
      return [createTextVNode(toDisplayString($setup.t("gj.compose.search")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : createCommentVNode("", true), $props.layout.includes("reset") ? (openBlock(), createBlock(_component_gj_button, {
    key: 2,
    onClick: $setup.handleReset
  }, {
    "default": withCtx(function() {
      return [createTextVNode(toDisplayString($setup.t("gj.compose.resetButtonText")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : createCommentVNode("", true), $props.layout.includes("plan") ? (openBlock(), createBlock(_component_gj_button_icon, {
    key: 3
  }, {
    "default": withCtx(function() {
      return [createVNode(_component_View, {
        style: {
          "width": "15px",
          "height": "15px"
        }
      })];
    }),
    _: 1
  })) : createCommentVNode("", true), createElementVNode("div", _hoisted_4$1, [renderSlot(_ctx.$slots, "right")])])]), $setup.isMore ? (openBlock(), createElementBlock("div", _hoisted_5$1, [renderSlot(_ctx.$slots, "high")])) : createCommentVNode("", true)], 64);
}
_sfc_main$1.render = _sfc_render$1;
var operateMap = {
  "Refresh": "refresh",
  "download": "export"
};
var _sfc_main = {
  name: "GjTableOperateLayout",
  components: {
    GjTooltip,
    GjSvgIcon,
    GjButtonIcon,
    Refresh: refresh
  },
  props: {
    layout: {
      type: Array,
      "default": function _default43() {
        return [];
      }
    }
  },
  emits: ["click-import", "click-export", "click-refresh", "click-help", "click-column"],
  setup: function setup47(props, _ref) {
    var emit = _ref.emit;
    var layouts = computed(function() {
      return props.layout.map(function(l) {
        return operateMap[l] || l;
      });
    });
    return {
      layouts,
      emit
    };
  }
};
var _hoisted_1 = {
  "class": "gj_operate-bar"
};
var _hoisted_2 = {
  "class": "gj_operate-bar__left"
};
var _hoisted_3 = /* @__PURE__ */ createTextVNode(" \u5BFC\u5165 ");
var _hoisted_4 = /* @__PURE__ */ createTextVNode(" \u5BFC\u51FA ");
var _hoisted_5 = {
  "class": "gj_operate-bar__right"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_gj_button = resolveComponent("gj-button");
  var _component_Refresh = resolveComponent("Refresh");
  var _component_gj_button_icon = resolveComponent("gj-button-icon");
  var _component_gj_svg_icon = resolveComponent("gj-svg-icon");
  var _component_gj_tooltip = resolveComponent("gj-tooltip");
  return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default"), $setup.layouts.includes("import") ? (openBlock(), createBlock(_component_gj_button, {
    key: 0,
    type: "default",
    onClick: _cache[0] || (_cache[0] = function($event) {
      return $setup.emit("click-import");
    })
  }, {
    "default": withCtx(function() {
      return [_hoisted_3];
    }),
    _: 1
  })) : createCommentVNode("", true), $setup.layouts.includes("export") ? (openBlock(), createBlock(_component_gj_button, {
    key: 1,
    type: "default",
    onClick: _cache[1] || (_cache[1] = function($event) {
      return $setup.emit("click-export");
    })
  }, {
    "default": withCtx(function() {
      return [_hoisted_4];
    }),
    _: 1
  })) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_5, [renderSlot(_ctx.$slots, "extra"), $setup.layouts.includes("refresh") ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_ctx.$slots.refresh ? renderSlot(_ctx.$slots, "refresh", {
    key: 0
  }) : (openBlock(), createBlock(_component_gj_button_icon, {
    key: 1,
    onClick: _cache[2] || (_cache[2] = function($event) {
      return $setup.emit("click-refresh");
    })
  }, {
    "default": withCtx(function() {
      return [createVNode(_component_Refresh, {
        style: {
          "width": "15px",
          "height": "15px"
        }
      })];
    }),
    _: 1
  }))], 64)) : createCommentVNode("", true), $setup.layouts.includes("column") ? (openBlock(), createBlock(_component_gj_tooltip, {
    key: 1,
    placement: "top",
    content: "\u8BBE\u7F6E\u81EA\u5B9A\u4E49\u5217"
  }, {
    "default": withCtx(function() {
      return [_ctx.$slots.column ? renderSlot(_ctx.$slots, "column", {
        key: 0
      }) : (openBlock(), createBlock(_component_gj_button_icon, {
        key: 1,
        onClick: _cache[3] || (_cache[3] = function($event) {
          return $setup.emit("click-column");
        })
      }, {
        "default": withCtx(function() {
          return [createVNode(_component_gj_svg_icon, {
            name: "jichupeizhi",
            size: 15
          })];
        }),
        _: 1
      }))];
    }),
    _: 3
  })) : createCommentVNode("", true), $setup.layouts.includes("help") ? (openBlock(), createBlock(_component_gj_tooltip, {
    key: 2,
    placement: "top",
    content: "\u5E2E\u52A9\u6587\u6863"
  }, {
    "default": withCtx(function() {
      return [_ctx.$slots.help ? renderSlot(_ctx.$slots, "help", {
        key: 0
      }) : (openBlock(), createBlock(_component_gj_button_icon, {
        key: 1,
        "class": "gj-svg-button",
        onClick: _cache[4] || (_cache[4] = function($event) {
          return $setup.emit("click-help");
        })
      }, {
        "default": withCtx(function() {
          return [createVNode(_component_gj_svg_icon, {
            name: "bangzhushouce",
            size: 15
          })];
        }),
        _: 1
      }))];
    }),
    _: 3
  })) : createCommentVNode("", true)])]);
}
_sfc_main.render = _sfc_render;
var GjTableBaseLayout = withInstall(_sfc_main$4);
var GjTableSearchLayout = withInstall(_sfc_main$1);
var GjTableOperateLayout = withInstall(_sfc_main);
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var en = _objectSpread$1({
  gj: {
    search: {
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      resetButtonText: "Reset",
      clear: "Clear",
      close: "Close",
      search: "Search",
      all: "All"
    },
    emptyText: "No Data",
    select: {
      all: "All"
    },
    compose: {
      search: "Search",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      resetButtonText: "Reset",
      morePlaceholder: "One item per line, please do not enter blank line, enter at most 200 lines",
      emptyText: "No Data"
    }
  }
}, en$1);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var zhCn = _objectSpread({
  gj: {
    search: {
      confirmButtonText: "\u786E\u5B9A",
      cancelButtonText: "\u53D6\u6D88",
      resetButtonText: "\u91CD\u7F6E",
      clear: "\u6E05\u7A7A",
      close: "\u5173\u95ED",
      search: "\u641C\u7D22",
      all: "\u5168\u90E8"
    },
    emptyText: "\u6682\u65E0\u6570\u636E",
    select: {
      all: "\u5168\u9009"
    },
    compose: {
      search: "\u641C\u7D22",
      confirmButtonText: "\u786E\u5B9A",
      cancelButtonText: "\u53D6\u6D88",
      resetButtonText: "\u91CD\u7F6E",
      morePlaceholder: "\u4E00\u884C\u4E00\u9879\uFF0C\u56DE\u8F66\u6362\u884C\uFF0C\u8BF7\u52FF\u8F93\u5165\u7A7A\u884C\uFF0C\u6700\u591A\u8F93\u5165200\u6761",
      emptyText: "\u6682\u65E0\u6570\u636E"
    }
  }
}, zh);
var components = [GjButton, GjButtonIcon, GjAlert, GjBadge, GjCheckbox, GjCheckboxGroup, GjDatePicker, GjDivider, GjDropdown, GjDropdownItem, GjDropdownOp, GjFilterGroup, GjImage, GjInput, GjInputAffix, GjInputComposeSelect, GjInputSearchMore, GjSelect, GjSelectOption, GjPagination, GjSelectSuper, GjSvgIcon, GjIcon, GjPopUp, GjPopover, GjPopoverSuper, GjProgress, GjRadio, GjRadioButton, GjRadioGroup, GjRate, GjScrollbar, GjSelectMore, GjSelectSingleTree, GjSelectTree, GjSpace, GjSteps, GjStep, GjSwitch, GjTab, GjTabItem, GjVxeTable, GjMiniList, GjMergeColumnTable, GjMergeRowTable, GjDragRowTable, GjTag, GjTooltip, GjTooltipIcon, GjTree, GjTransfer, GjAlertSuper, GjBreadcrumb, GjBreadcrumbItem, GjForm, GjFormItem, GjTimeline, GjTimelineItem, GjTabSuper, GjSelectComposeDatePicker, GjSelectLikeInput, GjText, GjTableBaseLayout, GjTableSearchLayout, GjTableOperateLayout];
var install = function install2(app, opts) {
  components.forEach(function(component) {
    app.use(component.install);
  });
  var defaultOpt = {
    modalTo: ""
  };
  var option2 = Object.assign(defaultOpt, opts);
  app.config.globalProperties.$GPLUS = option2;
};
var index = {
  GjButton,
  GjButtonIcon,
  GjAlert,
  GjBadge,
  GjCheckbox,
  GjCheckboxGroup,
  GjDatePicker,
  GjDivider,
  GjDropdown,
  GjDropdownItem,
  GjDropdownOp,
  GjFilterGroup,
  GjImage,
  GjInput,
  GjInputAffix,
  GjInputComposeSelect,
  GjInputSearchMore,
  GjSelect,
  GjSelectOption,
  GjPagination,
  GjSelectSuper,
  GjSvgIcon,
  GjIcon,
  GjPopUp,
  GjPopover,
  GjPopoverSuper,
  GjProgress,
  GjRadio,
  GjRadioButton,
  GjRadioGroup,
  GjRate,
  GjScrollbar,
  GjSelectMore,
  GjSelectSingleTree,
  GjSelectTree,
  GjSpace,
  GjSteps,
  GjStep,
  GjSwitch,
  GjTab,
  GjTabItem,
  GjVxeTable,
  GjMiniList,
  GjMergeColumnTable,
  GjMergeRowTable,
  GjDragRowTable,
  GjTag,
  GjTooltip,
  GjTooltipIcon,
  GjTree,
  GjTransfer,
  GjAlertSuper,
  GjBreadcrumb,
  GjBreadcrumbItem,
  GjForm,
  GjFormItem,
  GjTimeline,
  GjTimelineItem,
  GjTabSuper,
  GjSelectComposeDatePicker,
  GjSelectLikeInput,
  GjText,
  GjTableBaseLayout,
  GjTableSearchLayout,
  GjTableOperateLayout,
  install
};
export { GjAlert, GjAlertSuper, GjBadge, GjBreadcrumb, GjBreadcrumbItem, GjButton, GjButtonIcon, GjCheckbox, GjCheckboxGroup, GjDatePicker, GjDivider, GjDragRowTable, GjDropdown, GjDropdownItem, GjDropdownOp, GjFilterGroup, GjForm, GjFormItem, GjIcon, GjImage, GjInput, GjInputAffix, GjInputComposeSelect, GjInputSearchMore, GjMergeColumnTable, GjMergeRowTable, GjMiniList, GjPagination, GjPopUp, GjPopover, GjPopoverSuper, GjProgress, GjRadio, GjRadioButton, GjRadioGroup, GjRate, GjScrollbar, GjSelect, GjSelectComposeDatePicker, GjSelectLikeInput, GjSelectMore, GjSelectOption, GjSelectSingleTree, GjSelectSuper, GjSelectTree, GjSpace, GjStep, GjSteps, GjSvgIcon, GjSwitch, GjTab, GjTabItem, GjTabSuper, GjTableBaseLayout, GjTableOperateLayout, GjTableSearchLayout, GjTag, GjText, GjTimeline, GjTimelineItem, GjTooltip, GjTooltipIcon, GjTransfer, GjTree, GjVxeTable, index as default, en, install, zhCn as zh };
